<template>
  <div class="setting-area">
    <!-- Dealership -->
    <div class="Dealership">
      <!-- Dealership -->
      <div class="accordion" id="accordionExample30">
        <div class="card">
          <div class="card-header" id="headingOne30">
            <h2 class="mb-0">
              <button
                class="btn btn-link"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne30"
                aria-expanded="true"
                aria-controls="collapseOne30"
              >
                <div class="detais-title">
                  <h3>
                    <img
                      class="img-fluid arrow-down"
                      src="../../assets/img/arrow-down.svg"
                      alt=""
                    />Dealership
                  </h3>
                </div>
              </button>
            </h2>
          </div>

          <div
            id="collapseOne30"
            class="collapse show"
            aria-labelledby="headingOne30"
            data-parent="#accordionExample30"
          >
            <div class="card-body">
              <div class="setting-tables">
                <table class="table">
                  <tbody>
                    <tr>
                      <td>Name</td>
                      <td>
                        {{ dealer_detail.dl_name
                        }}<!-- <input type="text" class="form-control" placeholder="Jhon Due"> -->
                      </td>
                    </tr>
                    <tr>
                      <td>Address</td>
                      <td>{{ dealer_detail.dl_address }}</td>
                      <!-- <td><input type="text" class="form-control" placeholder="Jhondue@gmail.com"></td> -->
                    </tr>
                    <tr>
                      <td>Date of Activation</td>
                      <td>{{ dealer_detail.activation_date }}</td>
                      <!-- <td><input type="text" class="form-control" placeholder="12/08/2019"></td> -->
                    </tr>
                    <tr>
                      <td>CRM Email</td>
                      <td>{{ dealer_detail.dl_crm_email }}</td>
                      <!-- <td><input type="text" class="form-control" placeholder="due@gmail.com"></td> -->
                    </tr>
                    <tr>
                      <td>Lead XML Forwarding Email Address</td>
                      <td class="customWidth">
                        <input
                          type="text"
                          class="form-control"
                          name="xml_email_forwarding_address"
                          v-model="xml_email_forwarding_address"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  class="
                    form-group
                    d-flex
                    justify-content-end
                    align-items-center
                  "
                >
                  <button
                    class="rem-btn"
                    @click="updateXmlEmailForwardingAddress"
                    type="submit"
                  >
                    Update Forwarding Email Address
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="Dealership">
      <!-- Dealership -->
      <div class="accordion" id="smtpAccordion">
        <div class="card">
          <div class="card-header" id="smtpAccordionHeading">
            <h2 class="mb-0">
              <button
                class="btn btn-link"
                type="button"
                data-toggle="collapse"
                data-target="#collapseSmtpAccordion"
                aria-expanded="true"
                aria-controls="collapseSmtpAccordion"
              >
                <div class="detais-title">
                  <h3>
                    <img
                      class="img-fluid arrow-down"
                      src="../../assets/img/arrow-down.svg"
                      alt=""
                    />SMTP Details
                  </h3>
                </div>
              </button>
            </h2>
          </div>

          <div
            id="collapseSmtpAccordion"
            class="collapse show"
            aria-labelledby="smtpAccordionHeading"
            data-parent="#smtpAccordion"
          >
            <div class="card-body add-member">
              <form @submit.prevent="updateSmtpDetails">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Driver</label>
                    <input
                      type="text"
                      v-model="dealer_detail.driver"
                      class="form-control"
                      placeholder="Driver"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Outgoing Mail (SMTP) Server</label>
                    <input
                      type="text"
                      v-model="dealer_detail.out_host"
                      class="form-control"
                      placeholder="Outgoing Mail (SMTP) Server"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Outgoing Port</label>
                    <input
                      type="text"
                      v-model="dealer_detail.out_port"
                      class="form-control"
                      placeholder="Outgoing Port"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Incoming Mail (IMAP) Server</label>
                    <input
                      type="text"
                      v-model="dealer_detail.in_host"
                      class="form-control"
                      placeholder="Incoming Mail (IMAP) Server"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Incoming Port</label>
                    <input
                      type="text"
                      v-model="dealer_detail.in_port"
                      class="form-control"
                      placeholder="Incoming Port"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Username</label>
                    <input
                      type="text"
                      v-model="dealer_detail.username"
                      autocomplete="off"
                      value=""
                      class="form-control"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Password</label>
                    <input
                      type="text"
                      v-model="dealer_detail.password"
                      class="form-control"
                      placeholder="Password"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Encryption</label>
                    <select
                      class="form-control"
                      v-model="dealer_detail.encryption"
                    >
                      <option value="">Choose Encryption</option>
                      <option value="null">none</option>
                      <option value="tls">tls</option>
                      <option value="ssl">ssl</option>
                    </select>
                  </div>
                </div>
                <div
                  class="
                    form-group
                    d-flex
                    justify-content-end
                    align-items-center
                  "
                >
                  <button
                    :disabled="btnLoader"
                    type="submit"
                    class="rem-btn pull-right"
                  >
                    <span v-if="btnLoader"
                      ><span class="spinner-grow spinner-grow-sm"></span>
                      Loading...</span
                    >
                    <span v-if="!btnLoader"> Update SMTP Details</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Automated Tasks -->
    <div class="Dealership">
      <!-- Dealership -->
      <div class="accordion" id="accordionExample2001">
        <div class="card">
          <div class="card-header" id="headingOne2001">
            <h2 class="mb-0">
              <button
                class="btn btn-link"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne2001"
                aria-expanded="true"
                aria-controls="collapseOne2001"
              >
                <div class="detais-title">
                  <h3>
                    <img
                      class="img-fluid arrow-down"
                      src="../../assets/img/arrow-down.svg"
                      alt=""
                    />Automated Tasks
                  </h3>
                </div>
              </button>
            </h2>
          </div>

          <div
            id="collapseOne2001"
            class="collapse show"
            aria-labelledby="headingOne2001"
            data-parent="#accordionExample2001"
          >
            <div class="card-body">
              <!-- create-alert -->
              <div class="automated-tasks">
                <div class="row">
                  <div class="col-md-6">
                    <div class="automated-task-text mb-3">
                      <p>If UnSold Leadsheet has No Engagement in:</p>
                    </div>
                    <div class="row">
                      <!-- <div class="col-md-6">
                                                <div class="automated-task-text">
                                                    <p>Engagement Reminder (Call, Email, Text)</p>
                                                </div>
                                            </div> -->
                      <div
                        class="col-md-6"
                        v-for="(usold, key) in automated_tasks_arr.unsold"
                        :key="key"
                      >
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    :value="usold.value"
                                    class="form-control"
                                    :placeholder="usold.value"
                                    readonly
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">Day</div>
                                  </div>
                                </div>
                              </li>
                              <li class="show-delet">
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    true-value="1"
                                    false-value="0"
                                    v-model="usold.status"
                                    v-on:change="
                                      updateAutomatedTasks(
                                        automated_tasks_arr.unsold,
                                        'unsold',
                                        automated_tasks_arr.id
                                      )
                                    "
                                  />
                                  <span class="slider round"></span>
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="automated-task-text mb-3">
                      <p>Sold Leadsheet has No Engagement in:</p>
                    </div>
                    <div class="row">
                      <!-- <div class="col-md-6">
                                                <div class="automated-task-text">
                                                    <p>Engagement Reminder (Call, Email, Text)</p>
                                                </div>
                                            </div> -->
                      <div
                        class="col-md-6"
                        v-for="(sold, key) in automated_tasks_arr.sold"
                        :key="key"
                      >
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    :value="sold.value"
                                    class="form-control"
                                    :placeholder="sold.value"
                                    readonly
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">Day</div>
                                  </div>
                                </div>
                              </li>
                              <li class="show-delet">
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    true-value="1"
                                    false-value="0"
                                    v-model="sold.status"
                                    v-on:change="
                                      updateAutomatedTasks(
                                        automated_tasks_arr.sold,
                                        'sold',
                                        automated_tasks_arr.id
                                      )
                                    "
                                  />
                                  <span class="slider round"></span>
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- create-alert -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Leads Settings -->
    <div class="Leads-Settings">
      <div class="accordion" id="accordionExample32">
        <div class="card">
          <div class="card-header" id="headingOne32">
            <h2 class="mb-0">
              <button
                class="btn btn-link"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne32"
                aria-expanded="true"
                aria-controls="collapseOne32"
              >
                <div class="detais-title">
                  <h3>
                    <img
                      class="img-fluid arrow-down"
                      src="../../assets/img/arrow-down.svg"
                      alt=""
                    />Lead Settings
                  </h3>
                </div>
              </button>
              <div class="adddetais">
                <a
                  class="add-appoi"
                  href="#"
                  data-toggle="modal"
                  data-target="#sourceBudgetModel"
                  ><img
                    class="img-fluid"
                    src="../../assets/img/plus.svg"
                    alt=""
                  />
                  Lead Source</a
                >
              </div>
            </h2>
          </div>

          <div
            id="collapseOne32"
            class="collapse show"
            aria-labelledby="headingOne32"
            data-parent="#accordionExample32"
          >
            <div class="card-body">
              <div class="dif-table">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Lead Source</th>
                      <th>Lead Type</th>
                      <th>Monthly Budget</th>
                      <th>Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- <tr>
                                            <td>AutoTrader</td>
                                            <td><li class="navbar dropdown">
                                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Internet <img class="img-fluid arrow-downs" src="../../assets/img/arrow-down.svg" alt="">
                                            </a>
                                            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                                <a class="dropdown-item" href="#">Referral</a>
                                                <a class="dropdown-item" href="#">Referral</a>
                                                <a class="dropdown-item" href="#"><img class="img-fluid" src="../../assets/img/plus.svg" alt=""> Add Category</a>
                                            </div>
                                            </li></td>
                                            <td>$3000</td>
                                        </tr> -->
                    <tr v-for="sb in sourceData" :key="sb.b_id">
                      <td>{{ sb.ls_name }}</td>
                      <td>{{ sb.lt_name }}</td>
                      <td>${{ sb.b_budget }}</td>
                      <td>{{ sb.b_updated | formatDate("MMMM DD, YYYY") }}</td>
                      <td>
                        <img
                          style="cursor: pointer"
                          v-on:click="deleteSourceBudget(sb.b_id)"
                          class="img-fluid"
                          src="../../assets/img/Delete.svg"
                          alt=""
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="table-footer">
                  <ul>
                    <li>Round Robin</li>
                    <!-- <li><label class="switch">
                                            <input type="checkbox" checked>
                                            <span class="slider round"></span>
                                            </label>
                                        </li> -->
                    <li>
                      <label class="switch">
                        <input
                          type="checkbox"
                          true-value="1"
                          false-value="0"
                          v-model="settings.roundRobin.us_value"
                          v-on:change="updateRoundRobin()"
                        />
                        <span class="slider round"></span>
                      </label>
                    </li>

                    <li v-if="settings.roundRobin.us_value == 1">
                      <button
                        @click="openRoundRobinOn"
                        style="margin-left: 40px"
                        class="rem-btn"
                      >
                        Click to select users for round robin.
                      </button>
                    </li>
                    <li v-if="settings.roundRobin.us_value == 0">
                      <button
                        data-toggle="modal"
                        data-target="#singleuser"
                        style="margin-left: 40px"
                        class="rem-btn"
                      >
                        Click to select agent to get all leads
                      </button>
                    </li>
                    <li>
                      <button
                        @click="defaultleadsource"
                        style="margin-left: 8px"
                        class="rem-btn"
                      >
                        New Lead Source Default Routing ({{ sourcename }})
                      </button>
                    </li>
                    <!-- <li class="marginleft">Active time </li>
                                        <li>
                                            <div class="input-group">
                                                <input type="text" class="form-control" >
                                                <div class="input-group-prepend">
                                                    <div class="input-group-text">Mins</div>
                                                </div>
                                            </div>
                                        </li>
                                        <li><a href="#"><img class="img-fluid" src="../../assets/img/pencil.svg" alt=""> Edit</a></li> -->
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Alert Settings -->
    <div class="Dealership">
      <!-- Dealership -->
      <div class="accordion" id="accordionExample33">
        <div class="card">
          <div class="card-header" id="headingOne33">
            <h2 class="mb-0">
              <button
                class="btn btn-link"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne33"
                aria-expanded="true"
                aria-controls="collapseOne31"
              >
                <div class="detais-title">
                  <h3>
                    <img
                      class="img-fluid arrow-down"
                      src="../../assets/img/arrow-down.svg"
                      alt=""
                    />Alert Settings
                  </h3>
                </div>
              </button>
            </h2>
          </div>

          <div
            id="collapseOne33"
            class="collapse show"
            aria-labelledby="headingOne33"
            data-parent="#accordionExample33"
          >
            <div class="card-body">
              <!-- create-alert -->
              <div class="create-alerts">
                <div class="row">
                  <div class="col-md-6">
                    <div class="alert-text">
                      <p>Notify me if lead isn’t assigned in</p>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="alert-con">
                      <div class="table-footer">
                        <ul>
                          <li class="hide-alrt">
                            <label class="switch">
                              <input
                                type="checkbox"
                                true-value="1"
                                false-value="0"
                                v-model="settings['unassignedLead'].us_status"
                              />
                              <span class="slider round"></span>
                            </label>
                            <!-- <a class="alrt-delet" href="#"><img class="img-fluid" src="../../assets/img/Delete.svg" alt="" /></a> -->
                          </li>
                          <li>
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="settings['unassignedLead'].us_value"
                                class="form-control"
                                placeholder="0"
                              />
                              <div class="input-group-prepend">
                                <div class="input-group-text">
                                  <select
                                    class="form-control Filter"
                                    v-model="settings['unassignedLead'].us_unit"
                                  >
                                    <option value="min">Min</option>
                                    <option value="day">Day</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li>
                            <a
                              href="#"
                              v-on:click.stop.prevent="
                                updateSetting(settings['unassignedLead'])
                              "
                              class="rem-btn small-btn"
                              >Save
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="alert-text">
                      <p>Notify me if lead isn’t touched in</p>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="alert-con">
                      <div class="table-footer">
                        <ul>
                          <li class="hide-alrt">
                            <label class="switch">
                              <input
                                type="checkbox"
                                true-value="1"
                                false-value="0"
                                v-model="settings['touchAlert'].us_status"
                              />
                              <span class="slider round"></span>
                            </label>
                          </li>
                          <li>
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="settings['touchAlert'].us_value"
                                class="form-control"
                                placeholder="0"
                              />
                              <div class="input-group-prepend">
                                <div class="input-group-text">
                                  <select
                                    class="form-control Filter"
                                    v-model="settings['touchAlert'].us_unit"
                                  >
                                    <option value="min">Min</option>
                                    <option value="day">Day</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li>
                            <a
                              href="#"
                              v-on:click.stop.prevent="
                                updateSetting(settings['touchAlert'])
                              "
                              class="rem-btn small-btn"
                              >Save
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="row">
                                    <div class="col-md-6">
                                        <div class="alert-text">
                                            <p>Notify me if lead hasn’t been followed up with in</p>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="alert-con">
                                            <div class="table-footer">
                                                <ul>
                                                    <li>
                                                        <div class="input-group">
                                                            <input type="text" class="form-control"  />
                                                            <div class="input-group-prepend">
                                                                <div class="input-group-text">
                                                                    <select class="form-control Filter">
                                                                        <option>Day</option>
                                                                        <option>Min</option>
                                                                        <option>Sec</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <a href="#"><img class="img-fluid" src="../../assets/img/pencil.svg" alt="" /> </a>
                                                    </li>
                                                    <li class="hide-alrt">
                                                        <label class="switch">
                                                            <input type="checkbox" checked />
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <a class="alrt-delet" href="#"><img class="img-fluid" src="../../assets/img/Delete.svg" alt="" /></a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                <!-- <div class="row">
                                    <div class="col-md-6">
                                        <div class="alert-text">
                                            <p>Notify me when lead is marked lost</p>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="alert-con">
                                            <div class="table-footer">
                                                <ul>
                                                    <li>
                                                        <div class="input-group">
                                                            <input type="text" v-model="settings['lostAlert'].us_value" class="form-control" placeholder="0" />
                                                            <div class="input-group-prepend">
                                                                <div class="input-group-text">
                                                                    <select class="form-control Filter" v-model="settings['lostAlert'].us_unit">
                                                                        <option value="min">Min</option>
                                                                        <option value="day">Day</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <a href="#" v-on:click.stop.prevent="updateSetting(settings['lostAlert'])"><img class="img-fluid" src="../../assets/img/pencil.svg" alt="" /> </a>
                                                    </li>
                                                    <li class="show-delet">
                                                        <label class="switch">
                                                            <input type="checkbox" true-value="1" false-value="0" v-model="settings['lostAlert'].us_status" v-on:change="updateStatus(settings['lostAlert'])" />
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                <div class="row">
                  <div class="col-md-6">
                    <div class="alert-text">
                      <p>
                        Notify me when Leadsheet with no future Task scheduled
                        in
                      </p>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="alert-con">
                      <div class="table-footer">
                        <ul>
                          <li class="show-delet">
                            <label class="switch">
                              <input
                                type="checkbox"
                                true-value="1"
                                false-value="0"
                                v-model="settings['noFutureTask'].us_status"
                              />
                              <span class="slider round"></span>
                            </label>
                          </li>
                          <li>
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="settings['noFutureTask'].us_value"
                                class="form-control"
                                placeholder="0"
                              />
                              <div class="input-group-prepend">
                                <div class="input-group-text">
                                  <select
                                    class="form-control Filter"
                                    v-model="settings['noFutureTask'].us_unit"
                                  >
                                    <option value="day">Day</option>
                                    <!-- <option>Sec</option> -->
                                  </select>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li>
                            <a
                              href="#"
                              v-on:click.stop.prevent="
                                updateSetting(settings['noFutureTask'])
                              "
                              class="rem-btn small-btn"
                              >Save
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="row">
                                    <div class="col-md-6">
                                        <div class="alert-text">
                                            <p>Notify me when Leadsheet has Status Demo but no Vehicle of Interest</p>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="alert-con">
                                            <div class="table-footer">
                                                <ul>
                                                    <li class="show-delet">
                                                        <label class="switch">
                                                            <input type="checkbox" true-value="1" false-value="0" v-model="settings['noVOI'].us_status" />
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <div class="input-group">
                                                            <input type="text" v-model="settings['noVOI'].us_value" class="form-control" placeholder="0" />
                                                            <div class="input-group-prepend">
                                                                <div class="input-group-text">
                                                                    <select class="form-control Filter" v-model="settings['noVOI'].us_unit">
                                                                        <option value="min">Min</option>
                                                                        <option value="day">Day</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <a href="#" v-on:click.stop.prevent="updateSetting(settings['noVOI'])" class="rem-btn small-btn">Save </a>
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                <div class="row">
                  <div class="col-md-6">
                    <div class="alert-text">
                      <p>
                        Notify me when Leadsheet type of Phone, with no Set
                        Appointment in
                      </p>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="alert-con">
                      <div class="table-footer">
                        <ul>
                          <li class="show-delet">
                            <label class="switch">
                              <input
                                type="checkbox"
                                true-value="1"
                                false-value="0"
                                v-model="settings['noSetAppt'].us_status"
                              />
                              <span class="slider round"></span>
                            </label>
                          </li>
                          <li>
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="settings['noSetAppt'].us_value"
                                class="form-control"
                                placeholder="0"
                              />
                              <div class="input-group-prepend">
                                <div class="input-group-text">
                                  <select
                                    class="form-control Filter"
                                    v-model="settings['noSetAppt'].us_unit"
                                  >
                                    <option value="min">Min</option>
                                    <option value="day">Day</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li>
                            <a
                              href="#"
                              v-on:click.stop.prevent="
                                updateSetting(settings['noSetAppt'])
                              "
                              class="rem-btn small-btn"
                              >Save
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="alert-text">
                      <p>
                        Notify me when new Lead Recieved from Customer has an
                        Active Leadsheets
                      </p>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="alert-con">
                      <div class="table-footer">
                        <ul>
                          <li class="show-delet">
                            <label class="switch">
                              <input
                                type="checkbox"
                                true-value="1"
                                false-value="0"
                                v-model="
                                  settings['alreadyActiveLead'].us_status
                                "
                              />
                              <span class="slider round"></span>
                            </label>
                          </li>
                          <!-- <li>
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="settings['alreadyActiveLead'].us_value"
                                class="form-control"
                                placeholder="0"
                              />
                              <div class="input-group-prepend">
                                <div class="input-group-text">
                                  <select
                                    class="form-control Filter"
                                    v-model="
                                      settings['alreadyActiveLead'].us_unit
                                    "
                                  >
                                    <option value="min">Min</option>
                                    <option value="day">Day</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </li> -->
                          <li>
                            <a
                              href="#"
                              v-on:click.stop.prevent="
                                updateSetting(settings['alreadyActiveLead'])
                              "
                              class="rem-btn small-btn"
                              >Save
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="row">
                                    <div class="col-md-6">
                                        <div class="alert-text">
                                            <p>Notify me when new Lead Recieved from Customer with multiple Active Leadsheets</p>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="alert-con">
                                            <div class="table-footer">
                                                <ul>
                                                    <li class="show-delet">
                                                        <label class="switch">
                                                            <input type="checkbox" true-value="1" false-value="0" v-model="settings['multipleActiveLeads'].us_status" />
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <div class="input-group">
                                                            <input type="text" v-model="settings['multipleActiveLeads'].us_value" class="form-control" placeholder="0" />
                                                            <div class="input-group-prepend">
                                                                <div class="input-group-text">
                                                                    <select class="form-control Filter" v-model="settings['multipleActiveLeads'].us_unit">
                                                                        <option value="min">Min</option>
                                                                        <option value="day">Day</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <a href="#" v-on:click.stop.prevent="updateSetting(settings['multipleActiveLeads'])" class="rem-btn small-btn">Save </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                <!-- <div class="row">
                  <div class="col-md-6">
                    <div class="alert-text">
                      <p>
                        Notify me when Email Recieved from customer with no
                        response
                      </p>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="alert-con">
                      <div class="table-footer">
                        <ul>
                          <li class="show-delet">
                            <label class="switch">
                              <input
                                type="checkbox"
                                true-value="1"
                                false-value="0"
                                v-model="
                                  settings['noResponseOnEmail'].us_status
                                "
                              />
                              <span class="slider round"></span>
                            </label>
                          </li>
                          <li>
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="settings['noResponseOnEmail'].us_value"
                                class="form-control"
                                placeholder="0"
                              />
                              <div class="input-group-prepend">
                                <div class="input-group-text">
                                  <select
                                    class="form-control Filter"
                                    v-model="
                                      settings['noResponseOnEmail'].us_unit
                                    "
                                  >
                                    <option value="min">Min</option>
                                    <option value="day">Day</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li>
                            <a
                              href="#"
                              v-on:click.stop.prevent="
                                updateSetting(settings['noResponseOnEmail'])
                              "
                              class="rem-btn small-btn"
                              >Save
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div> -->
                <div class="row">
                  <div class="col-md-6">
                    <div class="alert-text">
                      <p>
                        Notify me when Salesperson Ended Previous Day with
                        Unfinished Tasks
                      </p>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="alert-con">
                      <div class="table-footer">
                        <ul>
                          <li class="show-delet">
                            <label class="switch">
                              <input
                                type="checkbox"
                                true-value="1"
                                false-value="0"
                                v-model="settings['unfinishedTasks'].us_status"
                              />
                              <span class="slider round"></span>
                            </label>
                          </li>
                          <li>
                            <a
                              href="#"
                              v-on:click.stop.prevent="
                                updateSetting(settings['unfinishedTasks'])
                              "
                              class="rem-btn small-btn"
                              >Save
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="alert-text">
                      <p>
                        Notify me when appointment status is pending after 24
                        hours
                      </p>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="alert-con">
                      <div class="table-footer">
                        <ul>
                          <li class="show-delet">
                            <label class="switch">
                              <input
                                type="checkbox"
                                true-value="1"
                                false-value="0"
                                v-model="
                                  settings['apptstatuspending'].us_status
                                "
                              />
                              <span class="slider round"></span>
                            </label>
                          </li>
                          <li>
                            <a
                              href="#"
                              v-on:click.stop.prevent="
                                updateSetting(settings['apptstatuspending'])
                              "
                              class="rem-btn small-btn"
                              >Save
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="alert-text">
                      <p>Notify me when lead is marked lost</p>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="alert-con">
                      <div class="table-footer">
                        <ul>
                          <li class="show-delet">
                            <label class="switch">
                              <input
                                type="checkbox"
                                true-value="1"
                                false-value="0"
                                v-model="settings['lostAlert'].us_status"
                              />
                              <span class="slider round"></span>
                            </label>
                          </li>
                          <li>
                            <a
                              href="#"
                              v-on:click.stop.prevent="
                                updateSetting(settings['lostAlert'])
                              "
                              class="rem-btn small-btn"
                              >Save
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="row">
                                    <div class="col-md-6">
                                        <div class="alert-text">
                                            <p>Notify me when Notified in Sticky Note Created / Completed</p>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="alert-con">
                                            <div class="table-footer">
                                                <ul>
                                                    <li class="show-delet">
                                                        <label class="switch">
                                                            <input type="checkbox" true-value="1" false-value="0" v-model="settings['stickyNote'].us_status" v-on:change="updateSetting(settings['stickyNote'])" />
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
              </div>
              <!-- create-alert -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="Dealership">
      <!-- Dealership -->
      <div class="accordion" id="accordionExample33">
        <div class="card">
          <div class="card-header" id="headingOne33">
            <h2 class="mb-0">
              <button
                class="btn btn-link"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne33"
                aria-expanded="true"
                aria-controls="collapseOne31"
              >
                <div class="detais-title">
                  <h3>
                    <img
                      class="img-fluid arrow-down"
                      src="../../assets/img/arrow-down.svg"
                      alt=""
                    />Owner Alert Settings
                  </h3>
                </div>
              </button>
            </h2>
          </div>

          <div
            id="collapseOne33"
            class="collapse show"
            aria-labelledby="headingOne33"
            data-parent="#accordionExample33"
          >
            <div class="card-body">
              <!-- create-alert -->
              <div class="create-alerts">
                <div class="row">
                  <div class="col-md-6">
                    <div class="alert-text">
                      <p>Notify me when alert has not been completed in</p>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="alert-con">
                      <div class="table-footer">
                        <ul>
                          <li class="hide-alrt">
                            <label class="switch">
                              <input
                                type="checkbox"
                                true-value="1"
                                false-value="0"
                                v-model="
                                  settings['alertnotcompleted'].us_status
                                "
                              />
                              <span class="slider round"></span>
                            </label>
                            <!-- <a class="alrt-delet" href="#"><img class="img-fluid" src="../../assets/img/Delete.svg" alt="" /></a> -->
                          </li>
                          <li>
                            <div class="input-group">
                              <input
                                type="text"
                                v-model="settings['alertnotcompleted'].us_value"
                                class="form-control"
                                placeholder="0"
                              />
                              <div class="input-group-prepend">
                                <div class="input-group-text">
                                  <select
                                    class="form-control Filter"
                                    v-model="
                                      settings['alertnotcompleted'].us_unit
                                    "
                                  >
                                    <option value="min">Min</option>
                                    <option value="day">Day</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li>
                            <a
                              href="#"
                              v-on:click.stop.prevent="
                                updateSetting(settings['alertnotcompleted'])
                              "
                              class="rem-btn small-btn"
                              >Save
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- create-alert -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Store Hours -->
    <div class="Dealership">
      <!-- Dealership -->
      <div class="accordion working" id="accordionExample34">
        <div class="card">
          <div class="card-header" id="headingOne34">
            <h2 class="mb-0">
              <button
                class="btn btn-link"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne34"
                aria-expanded="true"
                aria-controls="collapseOne31"
              >
                <div class="detais-title">
                  <h3>
                    <img
                      class="img-fluid arrow-down"
                      src="../../assets/img/arrow-down.svg"
                      alt=""
                    />Store Hours
                  </h3>
                </div>
              </button>
            </h2>
          </div>

          <div
            id="collapseOne34"
            class="collapse show"
            aria-labelledby="headingOne34"
            data-parent="#accordionExample34"
          >
            <div class="card-body">
              <div class="working-hours">
                <div class="day-stripe">
                  <div class="day-hours-heading">Day</div>

                  <div class="hours-open-div">
                    <div class="day-hour-time-heading hours-open-div-wrapper">
                      Open
                    </div>
                  </div>
                  <div class="close-hr hours-open-div">
                    <div class="day-hour-time-heading hours-open-div-wrapper">
                      Close
                    </div>
                  </div>
                </div>
                <div
                  class="day-stripe"
                  v-for="schedule in userSchedule"
                  :key="schedule.id"
                >
                  <div class="day-hours-div">
                    <toggle-button v-model="schedule.status" :labels="true" color="#19cd9d" />
                    {{ schedule.day_title }}
                  </div>
                  <div class="hours-open-div">
                    <div class="hours-open-div-wrapper">
                      <vue-timepicker
                        v-model="schedule.start_time"
                        format="hh:mm A"
                        :minute-interval="5"
                        close-on-complete
                        placeholder="hh:mm a"
                      ></vue-timepicker>
                    </div>
                  </div>
                  <div class="close-hr hours-open-div">
                    <div class="hours-open-div-wrapper pull-left">
                      <vue-timepicker
                        v-model="schedule.end_time"
                        format="hh:mm A"
                        :minute-interval="5"
                        close-on-complete
                        placeholder="hh:mm a"
                      ></vue-timepicker>
                    </div>
                    <div class="pull-right time-error">
                      <span
                        :id="'errorMessage' + schedule.id"
                        style="display: none"
                      ></span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="mt-3 text-right col-sm-12">
                    <button
                      class="rem-btn pull-right"
                      v-on:click="updateSchedule"
                    >
                      Update
                    </button>
                  </div>
                </div>

                <!-- <vue-timepicker format="hh:mm A" :minute-interval="5" close-on-complete></vue-timepicker>
                                <toggle-button v-model="myDataVariable" :labels="true"/> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Dealership">
      <!-- Dealership -->
      <div class="accordion" id="accordionExample40">
        <div class="card">
          <div class="card-header" id="headingOne40">
            <h2 class="mb-0">
              <button
                class="btn btn-link"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne40"
                aria-expanded="true"
                aria-controls="collapseOne40"
              >
                <div class="detais-title">
                  <h3>
                    <img
                      class="img-fluid arrow-down"
                      src="../../assets/img/arrow-down.svg"
                      alt=""
                    />
                    Request
                  </h3>
                </div>
              </button>
            </h2>
          </div>

          <div
            id="collapseOne40"
            class="collapse show"
            aria-labelledby="headingOne40"
            data-parent="#accordionExample40"
          >
            <div class="card-body">
              <form @submit.prevent="addRequest">
                <div class="add-member add-lead">
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label>Credit App</label
                      ><input
                        type="text"
                        autocomplete="stop"
                        class="form-control"
                        v-model="request.creditApp"
                      />
                    </div>
                    <div class="form-group col-md-12">
                      <label>Trade In</label
                      ><input
                        type="text"
                        autocomplete="stop"
                        class="form-control"
                        v-model="request.tradein"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Facebook Review</label
                    ><textarea
                      type="email"
                      autocomplete="stop"
                      class="form-control"
                      v-model="request.facebookreview"
                    ></textarea>
                  </div>
                  <div class="form-group">
                    <label>Google Review </label
                    ><textarea
                      type="tel"
                      class="form-control"
                      v-model="request.googlereview"
                    ></textarea>
                  </div>
                  <div class="mt-3 text-right col-sm-12">
                    <button
                      :disabled="btnLoader"
                      type="submit"
                      class="rem-btn pull-right"
                    >
                      <span v-if="btnLoader"
                        ><span class="spinner-grow spinner-grow-sm"></span>
                        Loading...</span
                      >
                      <span v-if="!btnLoader"> Add</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Dealership">
      <!-- Dealership -->
      <div class="accordion" id="accordionExample35">
        <div class="card">
          <div class="card-header" id="headingOne35">
            <h2 class="mb-0">
              <button
                class="btn btn-link"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne35"
                aria-expanded="true"
                aria-controls="collapseOne35"
              >
                <div class="detais-title">
                  <h3>
                    <img
                      class="img-fluid arrow-down"
                      src="../../assets/img/arrow-down.svg"
                      alt=""
                    />
                    Facebook
                  </h3>
                </div>
              </button>
            </h2>
          </div>

          <div
            id="collapseOne35"
            class="collapse show"
            aria-labelledby="headingOne35"
            data-parent="#accordionExample35"
          >
            <div class="card-body">
              <a class="fb connect" @click="AuthProvider">
                Sign in with Facebook
              </a>

              <div class="fbpage" v-if="dealer_detail.page_id">
                <a
                  target="_blank"
                  :href="'https://www.facebook.com/' + dealer_detail.page_id"
                  >Click here to view currently linked page</a
                >

                <!-- <a
                  v-if="dealer_detail.page_id"
                  class="rawleads"
                  @click="openincommingLeadmodal"
                  style="color: white; margin-left: 25px"
                  >Assign Incoming Messenger Leads</a
                > -->
              </div>
              <p v-else>No Facebook Page Authorize</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Dealership">
      <!-- Dealership -->
      <div class="accordion" id="accordionExample41">
        <div class="card">
          <div class="card-header" id="headingOne41">
            <h2 class="mb-0">
              <button
                class="btn btn-link"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne41"
                aria-expanded="true"
                aria-controls="collapseOne41"
              >
                <div class="detais-title">
                  <h3>
                    <img
                      class="img-fluid arrow-down"
                      src="../../assets/img/arrow-down.svg"
                      alt=""
                    />
                    Logs
                  </h3>
                </div>
              </button>
            </h2>
          </div>

          <div
            id="collapseOne41"
            class="collapse show"
            aria-labelledby="headingOne41"
            data-parent="#accordionExample41"
          >
            <div class="card-body">
              <router-link class="rawleads" :to="{ path: '/raw-leads' }">
                Raw leads</router-link
              >
              <router-link
                class="rawleads"
                style="margin-left: 10px"
                :to="{ path: '/login-logs' }"
              >
                Login logs</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Facebook Pages Modal-->

    <!--Manage Response tine -->
    <div
      class="Dealership"
      v-if="this.$storage.get('auth').user.user_type == 1"
    >
      <!-- Dealership -->
      <div class="accordion" id="accordionExample60">
        <div class="card">
          <div class="card-header" id="headingOne60">
            <h2 class="mb-0">
              <button
                class="btn btn-link"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne60"
                aria-expanded="true"
                aria-controls="collapseOne60"
              >
                <div class="detais-title">
                  <h3>
                    <img
                      class="img-fluid arrow-down"
                      src="../../assets/img/arrow-down.svg"
                      alt=""
                    />
                    Manage Response Time
                  </h3>
                </div>
              </button>
            </h2>
          </div>

          <div
            id="collapseOne60"
            class="collapse show"
            aria-labelledby="headingOne60"
            data-parent="#accordionExample60"
          >
            <div class="card-body">
              <a
                class="rawleads"
                data-toggle="modal"
                data-target="#resetResponseTime"
                style="color: white"
                >Reset Response Time</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Manage Response Time -->

    <div
      class="Dealership"
    >
      <!-- Dealership -->
      <div class="accordion" id="accordionExample2001">
        <div class="card">
          <div class="card-header" id="headingOne2001">
            <h2 class="mb-0">
              <button
                class="btn btn-link"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne2001"
                aria-expanded="true"
                aria-controls="collapseOne2001"
              >
                <div class="detais-title">
                  <h3>
                    <img
                      class="img-fluid arrow-down"
                      src="assets/img/arrow-down.svg"
                      alt=""
                    />Automated Tasks
                  </h3>
                </div>
              </button>
            </h2>
          </div>

          <div
            id="collapseOne2001"
            class="collapse show"
            aria-labelledby="headingOne2001"
            data-parent="#accordionExample2001"
          >
            <div class="card-body">
              <!-- create-alert -->
              <div class="automated">
                <div class="row">
                  <!--automated -->
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="alert-text">
                          <p>If Call Lead Handled With No Appointment</p>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    v-model="
                                      leadHandelWithNoAppoint.data[0].value
                                    "
                                    class="form-control"
                                    placeholder="1"
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="
                                          leadHandelWithNoAppoint.data[0].unit
                                        "
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li class="hide-alrt checka">
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    v-model="
                                      leadHandelWithNoAppoint.data[0].status
                                    "
                                    true-value="1"
                                    false-value="0"
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div class="alrt-delet">
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="type"
                                        value="text"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row1.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row1
                                          .sms_template
                                      "
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadHandelWithNoAppoint.row1
                                              .sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="type"
                                        value="email"
                                        class="checkboxes"
                                        id="email"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row1.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row1
                                          .email_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadHandelWithNoAppoint.row1
                                              .email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="type"
                                        value="call"
                                        class="checkboxes"
                                        id="call"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row1.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email
                                      <input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row1
                                            .manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row1
                                          .manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadHandelWithNoAppoint.row1
                                              .manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row1.time
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row1.hour
                                      "
                                    >
                                      <option value="null" disabled selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadHandelWithNoAppoint.row1.min"
                                    >
                                      <option value="null" disabled selected>
                                        Min
                                      </option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row1.daytime
                                      "
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <!-- single-alert -->
                      <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="
                                      leadHandelWithNoAppoint.data[1].value
                                    "
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="
                                          leadHandelWithNoAppoint.data[1].unit
                                        "
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>

                              <li
                                class="hide-alrt"
                                :class="
                                  leadHandelWithNoAppoint.data[1].status == 1
                                    ? 'checka'
                                    : ''
                                "
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    true-value="1"
                                    v-model="
                                      leadHandelWithNoAppoint.data[1].status
                                    "
                                    false-value="0"
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div
                                  class="alrt-delet"
                                  :class="
                                    leadHandelWithNoAppoint.data[1].status == 1
                                      ? 'checka'
                                      : ''
                                  "
                                >
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="row2"
                                        value="text"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row2.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row2
                                          .sms_template
                                      "
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadHandelWithNoAppoint.row2
                                              .sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="row2"
                                        value="email"
                                        class="checkboxes"
                                        id="email"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row2.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row2
                                          .email_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadHandelWithNoAppoint.row2
                                              .email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="row2"
                                        value="call"
                                        class="checkboxes"
                                        id="call"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row2.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email
                                      <input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row2
                                            .manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row2
                                          .manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadHandelWithNoAppoint.row2
                                              .manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row2.time
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row2.hour
                                      "
                                    >
                                      <option value="null" disabled selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadHandelWithNoAppoint.row2.min"
                                    >
                                      <option value="null" disabled selected>
                                        Min
                                      </option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row2.daytime
                                      "
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <!-- single-alert -->
                      <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="
                                      leadHandelWithNoAppoint.data[2].value
                                    "
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="
                                          leadHandelWithNoAppoint.data[2].unit
                                        "
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>

                              <li
                                class="hide-alrt"
                                :class="
                                  leadHandelWithNoAppoint.data[2].status == 1
                                    ? 'checka'
                                    : ''
                                "
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    v-model="
                                      leadHandelWithNoAppoint.data[2].status
                                    "
                                    true-value="1"
                                    false-value="0"
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div
                                  class="alrt-delet"
                                  :class="
                                    leadHandelWithNoAppoint.data[2].status == 1
                                      ? 'checka'
                                      : ''
                                  "
                                >
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="row3"
                                        value="text"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row3.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row3
                                          .sms_template
                                      "
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadHandelWithNoAppoint.row3
                                              .sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email<input
                                        type="radio"
                                        name="row3"
                                        value="email"
                                        class="checkboxes"
                                        id="email"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row3.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row3
                                          .email_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadHandelWithNoAppoint.row3
                                              .email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="row3"
                                        value="call"
                                        class="checkboxes"
                                        id="call"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row3.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row3
                                            .manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row3
                                          .manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadHandelWithNoAppoint.row3
                                              .manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row3.time
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row3.hour
                                      "
                                    >
                                      <option value="null" disabled selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadHandelWithNoAppoint.row3.min"
                                    >
                                      <option value="null" disabled selected>
                                        Min
                                      </option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row3.daytime
                                      "
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <!-- single-alert -->
                      <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="
                                      leadHandelWithNoAppoint.data[3].value
                                    "
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="
                                          leadHandelWithNoAppoint.data[3].unit
                                        "
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>

                              <li
                                class="hide-alrt"
                                :class="
                                  leadHandelWithNoAppoint.data[3].status == 1
                                    ? 'checka'
                                    : ''
                                "
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    v-model="
                                      leadHandelWithNoAppoint.data[3].status
                                    "
                                    true-value="1"
                                    false-value="0"
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div
                                  class="alrt-delet"
                                  :class="
                                    leadHandelWithNoAppoint.data[3].status == 1
                                      ? 'checka'
                                      : ''
                                  "
                                >
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="row4"
                                        value="text"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row4.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row4
                                          .sms_template
                                      "
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadHandelWithNoAppoint.row4
                                              .sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="row4"
                                        value="email"
                                        class="checkboxes"
                                        id="email"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row4.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row4
                                          .email_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadHandelWithNoAppoint.row4
                                              .email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="row4"
                                        value="call"
                                        class="checkboxes"
                                        id="call"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row4.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email
                                      <input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row4
                                            .manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row4
                                          .manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadHandelWithNoAppoint.row4
                                              .manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row4.time
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row4.hour
                                      "
                                    >
                                      <option value="null" disabled selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadHandelWithNoAppoint.row4.min"
                                    >
                                      <option value="null" disabled selected>
                                        Min
                                      </option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row4.daytime
                                      "
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <!-- single-alert -->
                      <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="
                                      leadHandelWithNoAppoint.data[4].value
                                    "
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="
                                          leadHandelWithNoAppoint.data[4].unit
                                        "
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>

                              <li
                                class="hide-alrt"
                                :class="
                                  leadHandelWithNoAppoint.data[4].status == 1
                                    ? 'checka'
                                    : ''
                                "
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    v-model="
                                      leadHandelWithNoAppoint.data[4].status
                                    "
                                    true-value="1"
                                    false-value="0"
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div
                                  class="alrt-delet"
                                  :class="
                                    leadHandelWithNoAppoint.data[4].status == 1
                                      ? 'checka'
                                      : ''
                                  "
                                >
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="type"
                                        value="text"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row5.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row5
                                          .sms_template
                                      "
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadHandelWithNoAppoint.row5
                                              .sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="type"
                                        value="email"
                                        class="checkboxes"
                                        id="email"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row5.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row5
                                          .email_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadHandelWithNoAppoint.row5
                                              .email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="type"
                                        value="call"
                                        class="checkboxes"
                                        id="call"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row5.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email
                                      <input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row5
                                            .manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row5
                                          .manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadHandelWithNoAppoint.row5
                                              .manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadHandelWithNoAppoint.row5.time
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row5.hour
                                      "
                                    >
                                      <option value="null" disabled selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadHandelWithNoAppoint.row5.min"
                                    >
                                      <option value="null" disabled selected>
                                        Min
                                      </option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadHandelWithNoAppoint.row5.daytime
                                      "
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- single-alert -->
                    </div>
                  </div>
                  <!-- automated -->

                  <!--automated -->
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="alert-text">
                          <p>If Leadsheet Is Marked Sold</p>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    v-model="leadmarksold.data[0].value"
                                    class="form-control"
                                    placeholder="1"
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="leadmarksold.data[0].unit"
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li class="hide-alrt checka">
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    v-model="leadmarksold.data[0].status"
                                    true-value="1"
                                    false-value="0"
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div class="alrt-delet">
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="leadmarksold"
                                        value="text"
                                        id="text"
                                        v-model="leadmarksold.row1.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row1.sms_template"
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarksold.row1.sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email<input
                                        type="radio"
                                        name="leadmarksold"
                                        value="email"
                                        id="email"
                                        v-model="leadmarksold.row1.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row1.email_template"
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarksold.row1.email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="leadmarksold"
                                        value="call"
                                        id="call"
                                        v-model="leadmarksold.row1.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email
                                      <input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadmarksold.row1.manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadmarksold.row1.manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarksold.row1.manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="leadmarksold.row1.time"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row1.hour"
                                    >
                                      <option value="null" disabled selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row1.min"
                                    >
                                      <option value="null" disabled selected>
                                        Min
                                      </option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row1.daytime"
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <!-- single-alert -->
                      <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    v-model="leadmarksold.data[1].value"
                                    class="form-control"
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="leadmarksold.data[1].unit"
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>

                              <li
                                class="hide-alrt"
                                :class="
                                  leadmarksold.data[1].status == 1
                                    ? 'checka'
                                    : ''
                                "
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    v-model="leadmarksold.data[1].status"
                                    true-value="1"
                                    false-value="0"
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div
                                  class="alrt-delet"
                                  :class="
                                    leadmarksold.data[1].status == 1
                                      ? 'checka'
                                      : ''
                                  "
                                >
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="row2"
                                        value="text"
                                        id="text"
                                        v-model="leadmarksold.row2.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row2.sms_template"
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarksold.row2.sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="row2"
                                        value="email"
                                        id="email"
                                        v-model="leadmarksold.row2.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row2.email_template"
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarksold.row2.email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="row2"
                                        value="call"
                                        id="call"
                                        v-model="leadmarksold.row2.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadmarksold.row2.manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadmarksold.row2.manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarksold.row2.manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="leadmarksold.row2.time"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row2.hour"
                                    >
                                      <option value="null" disabled selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row2.min"
                                    >
                                      <option value="null" disabled selected>
                                        Min
                                      </option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row2.daytime"
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <!-- single-alert -->
                      <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    v-model="leadmarksold.data[2].value"
                                    type="text"
                                    class="form-control"
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="leadmarksold.data[2].unit"
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>

                              <li
                                class="hide-alrt"
                                :class="
                                  leadmarksold.data[2].status == 1
                                    ? 'checka'
                                    : ''
                                "
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    true-value="1"
                                    false-value="0"
                                    v-model="leadmarksold.data[2].status"
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div
                                  class="alrt-delet"
                                  :class="
                                    leadmarksold.data[2].status == 1
                                      ? 'checka'
                                      : ''
                                  "
                                >
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="row3"
                                        value="text"
                                        id="text"
                                        v-model="leadmarksold.row3.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row3.sms_template"
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarksold.row3.sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="row3"
                                        value="email"
                                        id="email"
                                        v-model="leadmarksold.row3.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row3.email_template"
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarksold.row3.email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="row3"
                                        value="call"
                                        id="call"
                                        v-model="leadmarksold.row3.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadmarksold.row3.manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadmarksold.row3.manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarksold.row3.manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="leadmarksold.row3.time"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row3.hour"
                                    >
                                      <option value="null" disabled selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row3.min"
                                    >
                                      <option value="null" disabled selected>
                                        Min
                                      </option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row3.daytime"
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <!-- single-alert -->
                      <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    v-model="leadmarksold.data[3].value"
                                    class="form-control"
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="leadmarksold.data[3].unit"
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>

                              <li
                                class="hide-alrt"
                                :class="
                                  leadmarksold.data[3].status == 1
                                    ? 'checka'
                                    : ''
                                "
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    v-model="leadmarksold.data[3].status"
                                    true-value="1"
                                    false-value="0"
                                  />
                                  <span class="slider round"></span>
                                </label>

                                <div
                                  class="alrt-delet"
                                  :class="
                                    leadmarksold.data[3].status == 1
                                      ? 'checka'
                                      : ''
                                  "
                                >
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="row4"
                                        value="text"
                                        id="text"
                                        v-model="leadmarksold.row4.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row4.sms_template"
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarksold.row4.sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email<input
                                        type="radio"
                                        name="row4"
                                        value="email"
                                        id="email"
                                        v-model="leadmarksold.row4.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row4.email_template"
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarksold.row4.email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="row4"
                                        value="call"
                                        id="call"
                                        v-model="leadmarksold.row4.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email
                                      <input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadmarksold.row4.manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadmarksold.row4.manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarksold.row4.manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="leadmarksold.row4.time"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row4.hour"
                                    >
                                      <option value="null" disabled selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row4.min"
                                    >
                                      <option value="null" disabled selected>
                                        Min
                                      </option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row4.daytime"
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <!-- single-alert -->
                      <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    v-model="leadmarksold.data[4].value"
                                    class="form-control"
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="leadmarksold.data[4].unit"
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>

                              <li
                                class="hide-alrt"
                                :class="
                                  leadmarksold.data[4].status == 1
                                    ? 'checka'
                                    : ''
                                "
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    v-model="leadmarksold.data[4].status"
                                    true-value="1"
                                    false-value="0"
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div
                                  class="alrt-delet"
                                  :class="
                                    leadmarksold.data[4].status == 1
                                      ? 'checka'
                                      : ''
                                  "
                                >
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="row5"
                                        value="text"
                                        id="text"
                                        v-model="leadmarksold.row5.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row5.sms_template"
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarksold.row5.sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="row5"
                                        value="email"
                                        id="email"
                                        v-model="leadmarksold.row5.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row5.email_template"
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarksold.row5.email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="row5"
                                        value="call"
                                        id="call"
                                        v-model="leadmarksold.row5.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadmarksold.row5.manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadmarksold.row5.manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarksold.row5.manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="leadmarksold.row5.time"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row5.hour"
                                    >
                                      <option value="null" disabled selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row5.min"
                                    >
                                      <option value="null" disabled selected>
                                        Min
                                      </option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarksold.row5.daytime"
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- single-alert -->
                    </div>
                  </div>
                  <!-- automated -->

                  <!--automated -->
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="alert-text">
                          <p>If Leadsheet Marked Lost</p>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    v-model="leadmarklost.data[0].value"
                                    class="form-control"
                                    placeholder="1"
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="leadmarklost.data[0].unit"
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <li class="hide-alrt checka">
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    v-model="leadmarklost.data[0].status"
                                    true-value="1"
                                    false-value="0"
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div class="alrt-delet">
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="leadmarklost"
                                        value="text"
                                        id="text"
                                        v-model="leadmarklost.row1.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row1.sms_template"
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarklost.row1.sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="leadmarklost"
                                        value="email"
                                        id="email"
                                        v-model="leadmarklost.row1.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row1.email_template"
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarklost.row1.email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="leadmarklost"
                                        value="call"
                                        id="call"
                                        v-model="leadmarklost.row1.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email
                                      <input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadmarklost.row1.manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadmarklost.row1.manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarklost.row1.manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="leadmarklost.row1.time"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row1.hour"
                                    >
                                      <option value="null" disabled selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row1.min"
                                    >
                                      <option value="null" disabled selected>
                                        Min
                                      </option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row1.daytime"
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <!-- single-alert -->
                      <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    v-model="leadmarklost.data[1].value"
                                    class="form-control"
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="leadmarklost.data[1].unit"
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>

                              <li
                                class="hide-alrt"
                                :class="
                                  leadmarklost.data[1].status == 1
                                    ? 'checka'
                                    : ''
                                "
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    true-value="1"
                                    false-value="0"
                                    v-model="leadmarklost.data[1].status"
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div
                                  class="alrt-delet"
                                  :class="
                                    leadmarklost.data[1].status == 1
                                      ? 'checka'
                                      : ''
                                  "
                                >
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="row2"
                                        value="text"
                                        id="text"
                                        v-model="leadmarklost.row2.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row2.sms_template"
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarklost.row2.sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="row2"
                                        value="email"
                                        id="email"
                                        v-model="leadmarklost.row2.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row2.email_template"
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarklost.row2.email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="row2"
                                        value="call"
                                        id="call"
                                        v-model="leadmarklost.row2.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email
                                      <input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadmarklost.row2.manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadmarklost.row2.manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarklost.row2.manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="leadmarklost.row2.time"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row2.hour"
                                    >
                                      <option value="null" disabled selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row2.min"
                                    >
                                      <option value="null" disabled selected>
                                        Min
                                      </option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row2.daytime"
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <!-- single-alert -->
                      <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="leadmarklost.data[2].value"
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="leadmarklost.data[2].unit"
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>

                              <li
                                class="hide-alrt"
                                :class="
                                  leadmarklost.data[2].status == 1
                                    ? 'checka'
                                    : ''
                                "
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    true-value="1"
                                    false-value="0"
                                    v-model="leadmarklost.data[2].status"
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div
                                  class="alrt-delet"
                                  :class="
                                    leadmarklost.data[2].status == 1
                                      ? 'checka'
                                      : ''
                                  "
                                >
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="row3"
                                        value="text"
                                        id="text"
                                        v-model="leadmarklost.row3.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row3.sms_template"
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarklost.row3.sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="row3"
                                        value="email"
                                        id="email"
                                        v-model="leadmarklost.row3.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row3.email_template"
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarklost.row3.email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="row3"
                                        value="call"
                                        id="call"
                                        v-model="leadmarklost.row3.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email
                                      <input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadmarklost.row3.manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadmarklost.row3.manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarklost.row3.manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="leadmarklost.row3.time"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row3.hour"
                                    >
                                      <option value="null" disabled selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row3.min"
                                    >
                                      <option value="null" disabled selected>
                                        Min
                                      </option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row3.daytime"
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <!-- single-alert -->
                      <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    v-model="leadmarklost.data[3].value"
                                    class="form-control"
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="leadmarklost.data[3].unit"
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>

                              <li
                                class="hide-alrt"
                                :class="
                                  leadmarklost.data[3].status == 1
                                    ? 'checka'
                                    : ''
                                "
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    true-value="1"
                                    false-value="0"
                                    v-model="leadmarklost.data[3].status"
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div
                                  class="alrt-delet"
                                  :class="
                                    leadmarklost.data[3].status == 1
                                      ? 'checka'
                                      : ''
                                  "
                                >
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="row4"
                                        value="text"
                                        id="text"
                                        v-model="leadmarklost.row4.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row4.sms_template"
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarklost.row4.sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="row4"
                                        value="email"
                                        id="email"
                                        v-model="leadmarklost.row4.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row4.email_template"
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarklost.row4.email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="row4"
                                        value="call"
                                        id="call"
                                        v-model="leadmarklost.row4.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email
                                      <input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadmarklost.row4.manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadmarklost.row4.manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarklost.row4.manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="leadmarklost.row4.time"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row4.hour"
                                    >
                                      <option value="null" disabled selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row4.min"
                                    >
                                      <option value="null" disabled selected>
                                        Min
                                      </option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row4.daytime"
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <!-- single-alert -->
                      <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    v-model="leadmarklost.data[4].value"
                                    class="form-control"
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="leadmarklost.data[4].unit"
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>

                              <li
                                class="hide-alrt"
                                :class="
                                  leadmarklost.data[4].status == 1
                                    ? 'checka'
                                    : ''
                                "
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    true-value="1"
                                    false-value="0"
                                    v-model="leadmarklost.data[4].status"
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div
                                  class="alrt-delet"
                                  :class="
                                    leadmarklost.data[4].status == 1
                                      ? 'checka'
                                      : ''
                                  "
                                >
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="row5"
                                        value="text"
                                        id="text"
                                        v-model="leadmarklost.row5.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row5.sms_template"
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarklost.row5.sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="row5"
                                        value="email"
                                        id="email"
                                        v-model="leadmarklost.row5.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row5.email_template"
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarklost.row5.email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="row5"
                                        value="call"
                                        id="call"
                                        v-model="leadmarklost.row5.text_type"
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email
                                      <input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          leadmarklost.row5.manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        leadmarklost.row5.manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            leadmarklost.row5.manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="leadmarklost.row5.time"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row5.hour"
                                    >
                                      <option value="null" disabled selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row5.min"
                                    >
                                      <option value="null" disabled selected>
                                        Min
                                      </option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="leadmarklost.row5.daytime"
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- single-alert -->
                    </div>
                  </div>
                  <!-- automated -->

                  <!--automated -->
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="alert-text">
                          <p>If It’s Sold Customer’s Birthday</p>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <!-- <div class="input-group">
                                  <input
                                    type="text"
                                    v-model="
                                      soldcustommerbirthday.data[0].value
                                    "
                                    class="form-control"
                                    placeholder="1"
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="
                                          soldcustommerbirthday.data[0].unit
                                        "
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div> -->
                              </li>
                              <li
                                class="hide-alrt checka"
                                style="margin-left: 141px"
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    true-value="1"
                                    false-value="0"
                                    v-model="
                                      soldcustommerbirthday.data[0].status
                                    "
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div class="alrt-delet">
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="soldcustommerbirthday"
                                        value="text"
                                        id="text"
                                        v-model="
                                          soldcustommerbirthday.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.sms_template
                                      "
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            soldcustommerbirthday.sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="soldcustommerbirthday"
                                        value="email"
                                        id="email"
                                        v-model="
                                          soldcustommerbirthday.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.email_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            soldcustommerbirthday.email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="soldcustommerbirthday"
                                        value="call"
                                        id="call"
                                        v-model="
                                          soldcustommerbirthday.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email
                                      <input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          soldcustommerbirthday.manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            soldcustommerbirthday.manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="soldcustommerbirthday.time"
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="soldcustommerbirthday.hour"
                                    >
                                      <option value="null" selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="soldcustommerbirthday.min"
                                    >
                                      <option value="null" selected>Min</option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="soldcustommerbirthday.daytime"
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <!-- single-alert -->
                      <!-- single-alert -->
                      <!-- <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    v-model="soldcustommerbirthday.data[1].unit"
                                    class="form-control"
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="
                                          soldcustommerbirthday.data[1].value
                                        "
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>

                              <li
                                class="hide-alrt"
                                :class="
                                  soldcustommerbirthday.data[1].status == 1
                                    ? 'checka'
                                    : ''
                                "
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    true-value="1"
                                    false-value="0"
                                    v-model="
                                      soldcustommerbirthday.data[1].status
                                    "
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div
                                  class="alrt-delet"
                                  :class="
                                    soldcustommerbirthday.data[1].status == 1
                                      ? 'checka'
                                      : ''
                                  "
                                >
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="row2"
                                        value="text"
                                        id="text"
                                        v-model="
                                          soldcustommerbirthday.row2.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.row2.sms_template
                                      "
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            soldcustommerbirthday.row2
                                              .sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="row2"
                                        value="email"
                                        id="email"
                                        v-model="
                                          soldcustommerbirthday.row2.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.row2
                                          .email_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            soldcustommerbirthday.row2
                                              .email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="row2"
                                        value="call"
                                        id="call"
                                        v-model="
                                          soldcustommerbirthday.row2.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email
                                      <input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          soldcustommerbirthday.row2
                                            .manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.row2
                                          .manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            soldcustommerbirthday.row2
                                              .manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          soldcustommerbirthday.row2.time
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="soldcustommerbirthday.row2.hour"
                                    >
                                      <option value="null" selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="soldcustommerbirthday.row2.min"
                                    >
                                      <option value="null" selected>Min</option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.row2.daytime
                                      "
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div> -->
                      <!-- single-alert -->
                      <!-- single-alert -->
                      <!-- <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="
                                      soldcustommerbirthday.data[2].value
                                    "
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="
                                          soldcustommerbirthday.data[2].unit
                                        "
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>

                              <li
                                class="hide-alrt"
                                :class="
                                  soldcustommerbirthday.data[2].status == 1
                                    ? 'checka'
                                    : ''
                                "
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    true-value="1"
                                    false-value="0"
                                    v-model="
                                      soldcustommerbirthday.data[2].status
                                    "
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div
                                  class="alrt-delet"
                                  :class="
                                    soldcustommerbirthday.data[2].status == 1
                                      ? 'checka'
                                      : ''
                                  "
                                >
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="row3"
                                        value="text"
                                        id="text"
                                        v-model="
                                          soldcustommerbirthday.row3.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.row3.sms_template
                                      "
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            soldcustommerbirthday.row3
                                              .sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="row3"
                                        value="email"
                                        id="email"
                                        v-model="
                                          soldcustommerbirthday.row3.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.row3
                                          .email_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            soldcustommerbirthday.row3
                                              .email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="row3"
                                        value="call"
                                        id="call"
                                        v-model="
                                          soldcustommerbirthday.row3.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email
                                      <input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          soldcustommerbirthday.row3
                                            .manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.row3
                                          .manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            soldcustommerbirthday.row3
                                              .manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          soldcustommerbirthday.row3.time
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="soldcustommerbirthday.row3.hour"
                                    >
                                      <option value="null" selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="soldcustommerbirthday.row3.min"
                                    >
                                      <option value="null" selected>Min</option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.row3.daytime
                                      "
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div> -->
                      <!-- single-alert -->
                      <!-- single-alert -->
                      <!-- <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="
                                      soldcustommerbirthday.data[3].value
                                    "
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="
                                          soldcustommerbirthday.data[3].unit
                                        "
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>

                              <li
                                class="hide-alrt"
                                :class="
                                  soldcustommerbirthday.data[3].status == 1
                                    ? 'checka'
                                    : ''
                                "
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    true-value="1"
                                    false-value="0"
                                    v-model="
                                      soldcustommerbirthday.data[3].status
                                    "
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div
                                  class="alrt-delet"
                                  :class="
                                    soldcustommerbirthday.data[3].status == 1
                                      ? 'checka'
                                      : ''
                                  "
                                >
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="row4"
                                        value="text"
                                        id="text"
                                        v-model="
                                          soldcustommerbirthday.row4.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.row4.sms_template
                                      "
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            soldcustommerbirthday.row4
                                              .sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="row4"
                                        value="email"
                                        id="email"
                                        v-model="
                                          soldcustommerbirthday.row4.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.row4
                                          .email_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            soldcustommerbirthday.row4
                                              .email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="row4"
                                        value="call"
                                        id="call"
                                        v-model="
                                          soldcustommerbirthday.row4.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email
                                      <input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          soldcustommerbirthday.row4
                                            .manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.row4
                                          .manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            soldcustommerbirthday.row4
                                              .manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          soldcustommerbirthday.row4.time
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="soldcustommerbirthday.row4.hour"
                                    >
                                      <option value="null" selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="soldcustommerbirthday.row4.min"
                                    >
                                      <option value="null" selected>Min</option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.row4.daytime
                                      "
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div> -->
                      <!-- single-alert -->
                      <!-- single-alert -->
                      <!-- <div class="col-md-12">
                        <div class="alert-con">
                          <div class="table-footer">
                            <ul>
                              <li>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="
                                      soldcustommerbirthday.data[4].value
                                    "
                                  />
                                  <div class="input-group-prepend">
                                    <div class="input-group-text">
                                      <select
                                        class="form-control Filter"
                                        v-model="
                                          soldcustommerbirthday.data[4].unit
                                        "
                                      >
                                        <option>Day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </li>

                              <li
                                class="hide-alrt"
                                :class="
                                  soldcustommerbirthday.data[4].status == 1
                                    ? 'checka'
                                    : ''
                                "
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    true-value="1"
                                    false-value="0"
                                    v-model="
                                      soldcustommerbirthday.data[4].status
                                    "
                                  />
                                  <span class="slider round"></span>
                                </label>
                                <div
                                  class="alrt-delet"
                                  :class="
                                    soldcustommerbirthday.data[4].status == 1
                                      ? 'checka'
                                      : ''
                                  "
                                >
                                  <div class="sh">
                                    <label class="containerw"
                                      >Text
                                      <input
                                        type="radio"
                                        name="row5"
                                        value="text"
                                        id="text"
                                        v-model="
                                          soldcustommerbirthday.row5.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.row5.sms_template
                                      "
                                    >
                                      <option
                                        v-for="sms in sms_templates"
                                        :key="sms.id"
                                        :value="sms.id"
                                      >
                                        {{ sms.name }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate<input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            soldcustommerbirthday.row5
                                              .sms_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Email
                                      <input
                                        type="radio"
                                        name="row5"
                                        value="email"
                                        id="email"
                                        v-model="
                                          soldcustommerbirthday.row5.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.row5
                                          .email_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            soldcustommerbirthday.row5
                                              .email_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Call<input
                                        type="radio"
                                        name="row5"
                                        value="call"
                                        id="call"
                                        v-model="
                                          soldcustommerbirthday.row5.text_type
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>

                                    <label class="containerw"
                                      >Manager Email
                                      <input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          soldcustommerbirthday.row5
                                            .manager_email
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.row5
                                          .manager_template
                                      "
                                    >
                                      <option
                                        v-for="temp in email_templates"
                                        :key="temp.ut_id"
                                        :value="temp.ut_id"
                                      >
                                        {{ temp.ut_title }}
                                      </option>
                                    </select>

                                    <span class="autonns">
                                      <label class="switch auto">
                                        Automate
                                        <input
                                          type="checkbox"
                                          name="automate"
                                          true-value="1"
                                          false-value="0"
                                          v-model="
                                            soldcustommerbirthday.row5
                                              .manager_automate
                                          "
                                        />
                                        <span class="slider round"></span>
                                      </label>
                                    </span>

                                    <label class="containerw"
                                      >Time<input
                                        type="checkbox"
                                        true-value="1"
                                        false-value="0"
                                        v-model="
                                          soldcustommerbirthday.row5.time
                                        "
                                      />
                                      <span class="checkmark"></span>
                                    </label>
                                    <select
                                      class="form-control Filter"
                                      v-model="soldcustommerbirthday.row5.hour"
                                    >
                                      <option value="null" selected>
                                        Hours
                                      </option>
                                      <option value="00">00</option>
                                      <option value="01">01</option>
                                      <option value="02">02</option>
                                      <option value="03">03</option>
                                      <option value="04">04</option>
                                      <option value="05">05</option>
                                      <option value="06">06</option>
                                      <option value="07">07</option>
                                      <option value="08">08</option>
                                      <option value="09">09</option>
                                      <option value="10">10</option>
                                      <option value="11">11</option>
                                      <option value="12">12</option>
                                      <option value="13">13</option>
                                      <option value="14">14</option>
                                      <option value="15">15</option>
                                      <option value="16">16</option>
                                      <option value="17">17</option>
                                      <option value="18">18</option>
                                      <option value="19">19</option>
                                      <option value="20">20</option>
                                      <option value="21">21</option>
                                      <option value="22">22</option>
                                      <option value="23">23</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="soldcustommerbirthday.row5.min"
                                    >
                                      <option value="null" selected>Min</option>
                                      <option value="00">00</option>
                                      <option value="05">05</option>
                                      <option value="10">10</option>
                                      <option value="15">15</option>
                                      <option value="20">20</option>
                                      <option value="25">25</option>
                                      <option value="30">30</option>
                                      <option value="35">35</option>
                                      <option value="40">40</option>
                                      <option value="45">45</option>
                                      <option value="50">50</option>
                                      <option value="55">55</option>
                                    </select>
                                    <select
                                      class="form-control Filter"
                                      v-model="
                                        soldcustommerbirthday.row5.daytime
                                      "
                                    >
                                      <option value="PM">PM</option>
                                      <option value="AM">AM</option>
                                    </select>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div> -->
                      <!-- single-alert -->
                    </div>
                  </div>
                  <!-- automated -->
                </div>
              </div>
              <!-- create-alert -->
              <button class="rem-btn pull-right" @click="updatetasks">
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Dealership -->
    <div
      class="modal fade"
      id="facebookpages"
      tabindex="-1"
      role="dialog"
      aria-labelledby="sourceBudgetModelLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="sourceBudgetModelLabel">Select Page</h5>
            <a class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"
                ><img
                  class="img-fluid"
                  src="../../assets/img/23. Closex.svg"
                  alt=""
              /></span>
            </a>
          </div>
          <form @submit.prevent="selectFbPage">
            <div class="modal-body">
              <div class="lead-search">
                <div class="form-group">
                  <select
                    class="form-control"
                    id="fb_page"
                    v-model="val"
                    v-on:change="selectPage"
                    style="border: 1px solid black !important"
                  >
                    <option value="">Select Page</option>
                    <option
                      v-for="page in pages"
                      :key="page.id"
                      :value="page.id + '|' + page.access_token"
                    >
                      {{ page.name }}
                    </option>
                  </select>
                </div>
              </div>
              <!-- <div v-for="page in pages" :key="page.id">
                        <input
                          type="radio"
                          name="fb_page"
                          :value="page.id + '|' + page.access_token"
                        />
                        {{ page.name }}
                      </div> -->
            </div>

            <div class="modal-footer">
              <a href="#" class="add-btn" data-dismiss="modal"> Cancel</a>
              <button type="submit" class="rem-btn">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Lead Source Name Modal -->
    <div
      class="modal fade"
      id="sourceBudgetModel"
      tabindex="-1"
      role="dialog"
      aria-labelledby="sourceBudgetModelLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="sourceBudgetModelLabel">
              Lead Source Name
            </h5>
            <a class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"
                ><img
                  class="img-fluid"
                  src="../../assets/img/23. Closex.svg"
                  alt=""
              /></span>
            </a>
          </div>
          <form v-on:submit.prevent="addSourceBudget">
            <div class="modal-body">
              <div class="add-member">
                <div class="form-group">
                  <label>Lead Source</label>
                  <select class="form-control" v-model="source_.source">
                    <option value="">Select source</option>
                    <option
                      v-for="sorc in LSources"
                      :value="sorc.ls_id"
                      :key="sorc.ls_id"
                    >
                      {{ sorc.ls_name }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Lead Type</label>
                  <select class="form-control" v-model="source_.type">
                    <option value="">Select type</option>
                    <option
                      v-for="type in LTypes"
                      :value="type.lt_id"
                      :key="type.lt_id"
                    >
                      {{ type.lt_name }}
                    </option>
                  </select>
                </div>
                <!-- <div class="form-group">
                            <label for="inputAddress">Name</label>
                            <input type="text" v-model="source_.name" class="form-control" placeholder="Car.com">
                            </div> -->
                <div class="form-group">
                  <label for="inputAddress">Monthly Budget</label>
                  <input
                    type="text"
                    v-model="source_.budget"
                    class="form-control"
                    placeholder="$4000"
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <a href="#" class="add-btn" data-dismiss="modal"> Cancel</a>
              <button type="submit" class="rem-btn">Okay</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- leads-assign area  -->
    <div class="modal fade" id="openRoundRobinOn" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"></h5>
            <a class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"
                ><img
                  class="img-fluid"
                  src="../../assets/img/23. Closex.svg"
                  alt=""
              /></span>
            </a>
          </div>
          <form v-on:submit.prevent="addUsers">
            <div class="modal-body">
              <div class="add-member add-lead">
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <!-- <label for="inputEmail4">Users</label> -->
                    <multi-select
                      :searchable="true"
                      id="a_users"
                      :alreadySelected="selected_users"
                      textColumn="text"
                      placeholder="Select Agent"
                      v-model="users"
                      :options="allEmployees"
                    ></multi-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <a href="#" class="add-btn" data-dismiss="modal"
                ><img
                  class="img-fluid"
                  src="../../assets/img/22. Delete.svg"
                  alt=""
                />
                Cancel</a
              >
              <a
                href="#"
                class="add-btn"
                v-if="this.round_robin"
                @click="setDefault"
              >
                Set to default</a
              >
              <button type="submit" class="rem-btn">
                <img
                  class="img-fluid"
                  src="../../assets/img/23. Close.svg"
                  alt=""
                />
                Assign
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- / leads-assign area  -->
    <div class="modal fade" id="resetResponseTime" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"></h5>
            <a class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"
                ><img
                  class="img-fluid"
                  src="../../assets/img/23. Closex.svg"
                  alt=""
              /></span>
            </a>
          </div>
          <form v-on:submit.prevent="responseTime">
            <div class="modal-body">
              <div class="add-member add-lead">
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <!-- <label for="inputEmail4">Users</label> -->
                    <multi-select
                      :searchable="true"
                      id="aa_users"
                      :alreadySelected="responsetime"
                      textColumn="text"
                      placeholder="Select Agent"
                      v-model="responsetime"
                      :options="manageragent"
                    ></multi-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="rem-btn">Reset Response Time</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="assignincommmingleads"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"></h5>
            <a class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"
                ><img
                  class="img-fluid"
                  src="../../assets/img/23. Closex.svg"
                  alt=""
              /></span>
            </a>
          </div>
          <form v-on:submit.prevent="assignIncomingLeads">
            <div class="modal-body">
              <div class="add-member add-lead">
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <!-- <label for="inputEmail4">Users</label> -->
                    <SingleSelect
                      :alreadySelected="assignincomingleadss"
                      :searchable="true"
                      id="aaa_users"
                      textColumn="text"
                      placeholder="Select Agent"
                      v-model="assignincomingleadss"
                      :options="allEmployees"
                    ></SingleSelect>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="rem-btn">
                Assign Messenger Leads
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--Single User -->
    <div class="modal fade" id="singleuser" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"></h5>
            <a class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"
                ><img
                  class="img-fluid"
                  src="../../assets/img/23. Closex.svg"
                  alt=""
              /></span>
            </a>
          </div>
          <form v-on:submit.prevent="addUser">
            <div class="modal-body">
              <div class="add-member">
                <div class="form-row">
                  <div
                    class="form-group col-md-12"
                    v-if="settings.roundRobin.us_value == 0"
                  >
                    <div class="form-group">
                      <select
                        class="form-control"
                        id="exampleFormControlSelect1"
                        v-model="agent"
                      >
                        <option value="">Select Agent</option>
                        <option
                          v-for="emp in allEmployees"
                          :key="emp.id"
                          :value="emp.id"
                        >
                          {{ emp.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <a href="#" class="add-btn" data-dismiss="modal"
                ><img
                  class="img-fluid"
                  src="../../assets/img/22. Delete.svg"
                  alt=""
                />
                Cancel</a
              >
              <button type="submit" class="rem-btn">
                <img
                  class="img-fluid"
                  src="../../assets/img/23. Close.svg"
                  alt=""
                />
                Assign
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- / Single User  -->

    <!--Default Lead Source  -->
    <div class="modal fade" id="defaultleadsource" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"></h5>
            <a class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"
                ><img
                  class="img-fluid"
                  src="../../assets/img/23. Closex.svg"
                  alt=""
              /></span>
            </a>
          </div>
          <form v-on:submit.prevent="AddDefaultLeadSource">
            <div class="modal-body">
              <div class="add-member">
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <div class="form-group">
                      <select
                        class="form-control"
                        id="exampleFormControlSelect1"
                        v-model="defaultsource"
                      >
                        <option value="Select Agent" selected disabled>
                          Select Agent
                        </option>
                        <option
                          v-for="emp in allEmployees"
                          :value="emp.id"
                          :key="emp.id"
                        >
                          {{ emp.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <a href="#" class="add-btn" data-dismiss="modal"
                ><img
                  class="img-fluid"
                  src="../../assets/img/22. Delete.svg"
                  alt=""
                />
                Cancel</a
              >
              <button type="submit" class="rem-btn">
                <img
                  class="img-fluid"
                  src="../../assets/img/23. Close.svg"
                  alt=""
                />
                Assign
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--Default Lead Source  -->
    <div class="modal fade" id="defaultleadsource" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"></h5>
            <a class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"
                ><img
                  class="img-fluid"
                  src="../../assets/img/23. Closex.svg"
                  alt=""
              /></span>
            </a>
          </div>
          <form v-on:submit.prevent="AddDefaultLeadSource">
            <div class="modal-body">
              <div class="add-member">
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <div class="form-group">
                      <select
                        class="form-control"
                        id="exampleFormControlSelect1"
                        v-model="defaultsource"
                      >
                        <option value="Select Agent" selected disabled>
                          Select Agent
                        </option>
                        <option
                          v-for="emp in allEmployees"
                          :value="emp.id"
                          :key="emp.id"
                        >
                          {{ emp.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <a href="#" class="add-btn" data-dismiss="modal"
                ><img
                  class="img-fluid"
                  src="../../assets/img/22. Delete.svg"
                  alt=""
                />
                Cancel</a
              >
              <button type="submit" class="rem-btn">
                <img
                  class="img-fluid"
                  src="../../assets/img/23. Close.svg"
                  alt=""
                />
                Assign
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import { ToggleButton } from "vue-js-toggle-button";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import MultiSelect from "../helpers/MultiSelectWithCheckbox";
import SingleSelect from "../helpers/singleSelect";
export default {
  name: "Settings",
  // mixins: [ VueDaval ],
  // vdRules: {
  //     setting_:  {
  //         duration:{required: true},unit:{required: true}
  //    }
  // },
  components: {
    ToggleButton,
    VueTimepicker,
    MultiSelect,
    SingleSelect,
  },
  data() {
    return {
      sms_templates: [],
      email_templates: [],
      assignincomingleadss: {},
      numbers: [],
      type: "",
      loader: false,
      searchnumber: "",
      defaultsource: "",
      name: "",
      pass: "",
      sourcename: "",
      allemp: [],
      agent: "",
      all: "",
      users: [],
      responsetime: [],
      selected_users: [],
      selected_agents: [],
      round_robin: "",
      allEmployees: [],
      manageragent: [],
      dealer_detail: {
        name: "",
      },
      settings: {
        touchAlert: {
          us_value: "",
          us_unit: "min",
          us_type: "alert",
          us_slug: "touchAlert",
          us_status: 0,
        },
        unassignedLead: {
          us_value: "",
          us_unit: "min",
          us_type: "alert",
          us_slug: "unassignedLead",
          us_status: 0,
        },
        lostAlert: {
          us_value: "",
          us_unit: "min",
          us_type: "alert",
          us_slug: "lostAlert",
          us_status: 0,
        },
        noFutureTask: {
          us_value: "",
          us_unit: "day",
          us_type: "alert",
          us_slug: "noFutureTask",
          us_status: 0,
        },
        //'noVOI':{us_value:'',us_unit:'min',us_type:'alert',us_slug:'noVOI',us_status:0},
        noSetAppt: {
          us_value: "",
          us_unit: "min",
          us_type: "alert",
          us_slug: "noSetAppt",
          us_status: 0,
        },
        //'multipleActiveLeads':{us_value:'',us_unit:'min',us_type:'alert',us_slug:'multipleActiveLeads',us_status:0},
        noResponseOnEmail: {
          us_value: "",
          us_unit: "day",
          us_type: "alert",
          us_slug: "noResponseOnEmail",
          us_status: 0,
        },
        alreadyActiveLead: {
          us_value: "",
          us_unit: "min",
          us_type: "alert",
          us_slug: "alreadyActiveLead",
          us_status: 0,
        },
        unfinishedTasks: {
          us_value: "",
          us_unit: "",
          us_type: "alert",
          us_slug: "unfinishedTasks",
          us_status: 0,
        },
        alertnotcompleted: {
          us_value: "",
          us_unit: "",
          us_type: "alert",
          us_slug: "alertnotcompleted",
          us_status: 0,
        },
        apptstatuspending: {
          us_value: "",
          us_unit: "",
          us_type: "alert",
          us_slug: "apptstatuspending",
          us_status: 0,
        },

        //'stickyNote':{us_value:'',us_unit:'',us_type:'alert',us_slug:'stickyNote',us_status:0},
        roundRobin: { us_value: 0, us_id: "" },
      },
      source_: { budget: "", source: "", type: "" },
      sourceData: [],
      LSources: [],
      LTypes: {},
      userSchedule: [],
      errorMsg: false,
      automated_tasks: [],
      automated_tasks_arr: {
        unsold: [
          { value: 1, status: 0 },
          { value: 2, status: 0 },
          { value: 3, status: 0 },
          { value: 5, status: 0 },
          { value: 7, status: 0 },
          { value: 10, status: 0 },
          { value: 15, status: 0 },
          { value: 20, status: 0 },
          { value: 25, status: 0 },
          { value: 30, status: 0 },
          { value: 45, status: 0 },
          { value: 60, status: 0 },
        ],
        sold: [
          { value: 1, status: 0 },
          { value: 20, status: 0 },
          { value: 180, status: 0 },
          { value: 720, status: 0 },
        ],
        id: 0,
      },
      leadHandelWithNoAppoint: {
        text: "If Call Lead Handled With No Appointment",
        value: "",
        unit: "",
        slug: "leadwithnoappointment",
        status: 1,
        text_type: "",
        email_type: "",
        call_type: "",
        sms_template: 0,
        email_template: 0,
        sms_automate: 0,
        email_automate: 0,
        manager_email: 0,
        manager_template: 0,
        manager_automate: 0,
        time: 0,
        hour: "h",
        min: "m",
        daytime: "",
        data: [
          { value: 1, status: 0, unit: "", row: 1 },
          { value: 2, status: 0, unit: "", row: 2 },
          { value: 3, status: 0, unit: "", row: 3 },
          { value: 4, status: 0, unit: "", row: 4 },
          { value: 5, status: 0, unit: "", row: 5 },
        ],
        row1: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
        row2: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
        row3: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
        row4: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
        row5: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
      },
      leadmarksold: {
        text: "If Leadsheet Is Marked Sold",
        value: "",
        unit: "",
        slug: "leadmarksold",
        status: 1,
        text_type: "",
        email_type: "",
        call_type: "",
        sms_template: 0,
        email_template: 0,
        sms_automate: 0,
        email_automate: 0,
        manager_email: 0,
        manager_template: 0,
        manager_automate: 0,
        time: 0,
        hour: "h",
        min: "m",
        daytime: "",
        data: [
          { value: 1, status: 0, unit: "", row: 1 },
          { value: 2, status: 0, unit: "", row: 2 },
          { value: 3, status: 0, unit: "", row: 3 },
          { value: 4, status: 0, unit: "", row: 4 },
          { value: 5, status: 0, unit: "", row: 5 },
        ],
        row1: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
        row2: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
          data: [
            { value: 1, status: 0, unit: "", row: 1 },
            { value: 2, status: 0, unit: "", row: 2 },
            { value: 3, status: 0, unit: "", row: 3 },
            { value: 4, status: 0, unit: "", row: 4 },
            { value: 5, status: 0, unit: "", row: 5 },
          ],
        },
        row3: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
        row4: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
        row5: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
      },
      leadmarklost: {
        text: "If Leadsheet Is Marked Lost",
        value: "",
        unit: "",
        slug: "leadmarklost",
        status: 1,
        text_type: "",
        email_type: "",
        call_type: "",
        sms_template: 0,
        email_template: 0,
        sms_automate: 0,
        email_automate: 0,
        manager_email: 0,
        manager_template: 0,
        manager_automate: 0,
        time: 0,
        hour: "h",
        min: "m",
        daytime: "",
        data: [
          { value: 1, status: 0, unit: "", row: 1 },
          { value: 2, status: 0, unit: "", row: 2 },
          { value: 3, status: 0, unit: "", row: 3 },
          { value: 4, status: 0, unit: "", row: 4 },
          { value: 5, status: 0, unit: "", row: 5 },
        ],
        row1: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
        row2: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
          data: [
            { value: 1, status: 0, unit: "", row: 1 },
            { value: 2, status: 0, unit: "", row: 2 },
            { value: 3, status: 0, unit: "", row: 3 },
            { value: 4, status: 0, unit: "", row: 4 },
            { value: 5, status: 0, unit: "", row: 5 },
          ],
        },
        row3: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
        row4: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
        row5: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
      },
      soldcustommerbirthday: {
        text: "If It’s Sold Customer’s Birthday",
        value: "",
        unit: "",
        slug: "soldcustommerbirthday",
        status: 1,
        text_type: "",
        email_type: "",
        call_type: "",
        sms_template: 0,
        email_template: 0,
        sms_automate: 0,
        email_automate: 0,
        manager_email: 0,
        manager_template: 0,
        manager_automate: 0,
        time: 0,
        hour: "",
        min: "",
        daytime: "",
        data: [
          { value: 1, status: 0, unit: "", row: 1 },
          { value: 2, status: 0, unit: "", row: 2 },
          { value: 3, status: 0, unit: "", row: 3 },
          { value: 4, status: 0, unit: "", row: 4 },
          { value: 5, status: 0, unit: "", row: 5 },
        ],
        row1: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
        row2: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
          data: [
            { value: 1, status: 0, unit: "", row: 1 },
            { value: 2, status: 0, unit: "", row: 2 },
            { value: 3, status: 0, unit: "", row: 3 },
            { value: 4, status: 0, unit: "", row: 4 },
            { value: 5, status: 0, unit: "", row: 5 },
          ],
        },
        row3: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
        row4: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
        row5: {
          value: "",
          unit: "",
          status: 1,
          text_type: "",
          email_type: "",
          call_type: "",
          sms_template: 0,
          email_template: 0,
          sms_automate: 0,
          email_automate: 0,
          manager_email: 0,
          manager_template: 0,
          manager_automate: 0,
          time: 0,
          hour: "h",
          min: "m",
          daytime: "",
        },
      },
      val: "",
      pages: [],
      dd123: [],
      request: {},
      btnLoader: false,
      xml_email_forwarding_address: "",
    };
  },
  created() {
    this.getSetting();
    this.SourceBudget();
    this.getLeadSource();
    this.getLeadType();
    this.getSchedule();
    this.getDealerDetail();
    this.getAllEmployees();
    this.getagentsmanagerlist();
    this.getRequest();
    this.getAutomatedTasks();
    this.getSmsTemplates();
    this.getTemplates();
  },

  methods: {
    getSmsTemplates() {
      axios
        .get("get_smstemplates", {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.sms_templates = res.data.success;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTemplates() {
      axios
        .get("get_templates/1", {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.email_templates = res.data.success;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updatetasks(slug, index, value, event) {
      console.log(event);
      console.log(index);
      console.log(value);
      console.log(slug);
      var data = [
        this.leadHandelWithNoAppoint,
        this.leadmarksold,
        this.leadmarklost,
        this.soldcustommerbirthday,
      ];
      axios
        .post(
          "updateAutomatedTasksData",
          { data: data },
          {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            this.$toast.open({
              position: "top-right",
              message: "Automated Tasks Updated",
              type: "success",
            });
            $("#assignincommmingleads").modal("hide");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openincommingLeadmodal() {
      if (this.dealer_detail.dl_incomming_messenger_leads != "") {
        this.allemp.forEach((emp) => {
          if (emp.id == this.dealer_detail.dl_incomming_messenger_leads) {
            this.assignincomingleadss = { d: emp.id, text: emp.name };
          }
        });
      }
      $("#assignincommmingleads").modal("show");
    },
    assignIncomingLeads() {
      axios
        .post(
          "add/incomminglead/agent",
          { agent: this.assignincomingleadss },
          {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            this.$toast.open({
              position: "top-right",
              message: "Agent Assigned For InComming Messanger Leads",
              type: "success",
            });
            $("#assignincommmingleads").modal("hide");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    responseTime() {
      axios
        .post(
          "resetResponseTime",
          { agent: this.responsetime },
          {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            $("#resetResponseTime").modal("hide");
            this.$toast.open({
              position: "top-right",
              message: res.data.message,
              type: "success",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    defaultleadsource() {
      $("#defaultleadsource").modal("show");
    },
    getDefaultLeadSource(id) {
      axios
        .get("get/default/source/" + id, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          const data = res.data;
          if (data.success) {
            this.sourcename = data.source;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    AddDefaultLeadSource() {
      this.btnLoader = true;
      axios
        .post(
          "add/defaultsource",
          { defaultsource: this.defaultsource },
          {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            this.getDefaultLeadSource(res.data.source);
            this.btnLoader = false;
            $("#defaultleadsource").modal("hide");
            this.$toast.open({
              position: "top-right",
              message: res.data.message,
            });
          }
        })
        .catch((err) => {
          this.btnLoader = false;
          console.log(err);
        });
    },
    getRequest() {
      axios
        .get("get/request", {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          const data = res.data;
          if (data.status) {
            this.request.creditApp = data.data.dl_creditapp;
            this.request.tradein = data.data.dl_tradein;
            this.request.facebookreview = data.data.dl_facebookreview;
            this.request.googlereview = data.data.dl_googlereview;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addRequest() {
      this.btnLoader = true;
      axios
        .post("add/request", this.request, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.status) {
            this.btnLoader = false;
          }
        })
        .catch((err) => {
          this.btnLoader = false;
          console.log(err);
        });
    },
    setDefault() {
      axios
        .get("setDefault", {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.selected_users = [];
            this.users = [];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openRoundRobinOn() {
      // console.log)

      // var dd = [];
      if (this.round_robin) {
        var user_ids = this.round_robin.split(",");

        var dd = [];
        this.allemp.forEach((emp) => {
          if (user_ids.indexOf("" + emp.id) !== -1) {
            dd.push({ id: emp.id, text: emp.name });
          }
        });
        this.selected_users = dd;
        this.users = this.selected_users;
      }

      $("#openRoundRobinOn").modal("show");
    },
    addUser() {
      axios
        .post(
          "add/robin/Agent",
          { agent: this.agent },
          {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            window.location.href = "";
            $("#singleuser").modal("hide");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addUsers() {
      axios
        .post(
          "add/robin/agents",
          { users: this.users },
          {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            // var ids ='';
            // if(this.users.length>0){
            //    this.users.forEach((data) => {
            //   if(ids!=""){
            //     ids +=','
            //   }
            //     ids +=data.id

            // });
            // this.round_robin = ids
            // }else{
            //   this.round_robin = ''
            // }
            window.location.href = "";
            $("#openRoundRobinOn").modal("hide");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllEmployees() {
      axios
        .get("all_employees/2", {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          const data = res.data;
          if (data.success) {
            this.allemp = data.success;
            if (data.success.length > 0) {
              var dd = [];
              $.each(data.success, function (key, value) {
                dd.push({ id: value.id, text: value.name });
              });
              this.allEmployees = dd;

              if (this.all == true) {
                this.selected_users = dd;
                this.users = dd;
                this.all = "";
              }

              //console.log(this.allEmployees);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getagentsmanagerlist() {
      axios
        .get("manageragentList", {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          const data = res.data;
          if (data.success) {
            this.allemp = data.success;
            if (data.success.length > 0) {
              var dd = [];
              $.each(data.success, function (key, value) {
                dd.push({ id: value.id, text: value.name });
              });
              this.manageragent = dd;

              if (this.all == true) {
                this.selected_users = dd;
                this.users = dd;
                this.all = "";
              }

              //console.log(this.allEmployees);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    AuthProvider() {
      this.pages = [];
      axios
        .get("/sociallogin")
        .then((res) => {
          console.log(res);
          if (res.data.url) {
            window.location.href = res.data.url;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectPage() {
      $("#fb_page").change(function () {
        this.val = $(this).val();
      });
    },
    getPages() {
      axios
        .post(
          "getPages",
          { fbToken: this.$route.query.fbToken },
          {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            res.data.pages.forEach((data) => {
              console.log(data.name);
              this.pages.push({
                name: data.name,
                id: data.id,
                access_token: data.access_token,
              });
            });
            $("#facebookpages").modal("show");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectFbPage() {
      var val = $("#fb_page").val();
      axios
        .post(
          "selectpage",
          { data: val },
          {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          }
        )
        .then((res) => {
          if (res.data.status) {
            $("#facebookpages").modal("hide");
            alert(res.data.message);
            this.$router.push("/settings");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateAutomatedTasks(data, type, id) {
      //console.log(data)
      axios
        .post(
          "update_automated_tasks",
          { data: data, type: type, id: id },
          {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          }
        )
        .then((res) => {
          if (res.data.success) {
            this.$toast.open({
              position: "top-right",
              message: res.data.success,
              type: "success",
            });
            console.log(res.data);
            if (
              res.data.id != undefined &&
              res.data.id != "undefined" &&
              res.data.id != null &&
              res.data.id != ""
            ) {
              this.automated_tasks_arr.id = res.data.id;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLeadType() {
      axios
        .get("lead_types")
        .then((res) => {
          if (res.data.success) {
            this.LTypes = res.data.success;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    SourceBudget() {
      axios
        .get("get_source_budgets", {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.sourceData = res.data.success;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addSourceBudget() {
      //  console.log(this.source_);
      axios
        .post("add_source_budget", this.source_, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.SourceBudget();
            $("#sourceBudgetModel").modal("hide");
            this.source_ = { budget: "", source: "", type: "" };
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLeadSource() {
      axios
        .get("dealer/lead/sources", {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.LSources = res.data.success;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteSourceBudget(id) {
      axios
        .get("delete_source_budget/" + id, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.SourceBudget();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateStatus(par) {
      console.log(par);
      axios
        .post("update_setting_status", par, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.success) {
            console.log(res.data.success);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateSetting(setting_) {
      //this.setting_.type = type
      //this.setting_.slug = slug

      //this.$vd.setting_.$validate().then(() => {
      console.log(setting_);
      axios
        .post("update_setting", setting_, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.$toast.open({
              position: "top-right",
              message: res.data.success,
              type: "success",
            });
          }
          if (res.data.error) {
            this.$toast.open({
              position: "top-right",
              message: res.data.error,
              type: "info",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });

      // }).catch(() => {
      //     console.log(this.$vd.setting_.$errors)
      // });
    },
    updateRoundRobin() {
      console.log(this.settings.roundRobin);
      axios
        .post("update_round_robin", this.settings.roundRobin, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.success) {
            console.log(res.data.success);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSetting() {
      axios
        .get("get_settings", {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          const data = res.data;
          this.sData = data.success;

          if (
            this.sData["roundRobin"] != undefined &&
            this.sData["roundRobin"] != "undefined" &&
            this.sData["roundRobin"] != null &&
            this.sData["roundRobin"] != ""
          ) {
            this.settings.roundRobin.us_value =
              this.sData["roundRobin"].us_value;
            this.settings.roundRobin.us_id = this.sData["roundRobin"].us_id;
          }
          if (
            this.sData["touchAlert"] != undefined &&
            this.sData["touchAlert"] != "undefined" &&
            this.sData["touchAlert"] != null &&
            this.sData["touchAlert"] != ""
          ) {
            this.settings.touchAlert = this.sData["touchAlert"];
          }
          if (
            this.sData["lostAlert"] != undefined &&
            this.sData["lostAlert"] != "undefined" &&
            this.sData["lostAlert"] != null &&
            this.sData["lostAlert"] != ""
          ) {
            this.settings.lostAlert = this.sData["lostAlert"];
          }
          if (
            this.sData["unfinishedTasks"] != undefined &&
            this.sData["unfinishedTasks"] != "undefined" &&
            this.sData["unfinishedTasks"] != null &&
            this.sData["unfinishedTasks"] != ""
          ) {
            this.settings.unfinishedTasks = this.sData["unfinishedTasks"];
          }
          // if (this.sData['stickyNote'] != undefined && this.sData['stickyNote'] != 'undefined' && this.sData['stickyNote'] != null && this.sData['stickyNote'] != '') {
          //     this.settings.stickyNote = this.sData['stickyNote']
          // }
          if (
            this.sData["unassignedLead"] != undefined &&
            this.sData["unassignedLead"] != "undefined" &&
            this.sData["unassignedLead"] != null &&
            this.sData["unassignedLead"] != ""
          ) {
            this.settings.unassignedLead = this.sData["unassignedLead"];
          }
          if (
            this.sData["noFutureTask"] != undefined &&
            this.sData["noFutureTask"] != "undefined" &&
            this.sData["noFutureTask"] != null &&
            this.sData["noFutureTask"] != ""
          ) {
            this.settings.noFutureTask = this.sData["noFutureTask"];
          }
          // if (this.sData['noVOI'] != undefined && this.sData['noVOI'] != 'undefined' && this.sData['noVOI'] != null && this.sData['noVOI'] != '') {
          //     this.settings.noVOI = this.sData['noVOI']
          // }
          if (
            this.sData["noSetAppt"] != undefined &&
            this.sData["noSetAppt"] != "undefined" &&
            this.sData["noSetAppt"] != null &&
            this.sData["noSetAppt"] != ""
          ) {
            this.settings.noSetAppt = this.sData["noSetAppt"];
          }
          if (
            this.sData["apptstatuspending"] != undefined &&
            this.sData["apptstatuspending"] != "undefined" &&
            this.sData["apptstatuspending"] != null &&
            this.sData["apptstatuspending"] != ""
          ) {
            this.settings.apptstatuspending = this.sData["apptstatuspending"];
          }
          // if (this.sData['multipleActiveLeads'] != undefined && this.sData['multipleActiveLeads'] != 'undefined' && this.sData['multipleActiveLeads'] != null && this.sData['multipleActiveLeads'] != '') {
          //     this.settings.multipleActiveLeads = this.sData['multipleActiveLeads']
          // }
          if (
            this.sData["noResponseOnEmail"] != undefined &&
            this.sData["noResponseOnEmail"] != "undefined" &&
            this.sData["noResponseOnEmail"] != null &&
            this.sData["noResponseOnEmail"] != ""
          ) {
            this.settings.noResponseOnEmail = this.sData["noResponseOnEmail"];
          }
          if (
            this.sData["alreadyActiveLead"] != undefined &&
            this.sData["alreadyActiveLead"] != "undefined" &&
            this.sData["alreadyActiveLead"] != null &&
            this.sData["alreadyActiveLead"] != ""
          ) {
            this.settings.alreadyActiveLead = this.sData["alreadyActiveLead"];
          }

          if (
            this.sData["alertnotcompleted"] != undefined &&
            this.sData["alertnotcompleted"] != "undefined" &&
            this.sData["alertnotcompleted"] != null &&
            this.sData["alertnotcompleted"] != ""
          ) {
            this.settings.alertnotcompleted = this.sData["alertnotcompleted"];
          }

          if (
            this.sData["unsold"] != undefined &&
            this.sData["unsold"] != "undefined" &&
            this.sData["unsold"] != null &&
            this.sData["unsold"] != ""
          ) {
            this.automated_tasks_arr.unsold = JSON.parse(
              this.sData["unsold"].us_value_in_arr
            );
            this.automated_tasks_arr.id = this.sData["unsold"].us_id;
          }
          if (
            this.sData["sold"] != undefined &&
            this.sData["sold"] != "undefined" &&
            this.sData["sold"] != null &&
            this.sData["sold"] != ""
          ) {
            this.automated_tasks_arr.sold = JSON.parse(
              this.sData["sold"].us_value_in_arr
            );
            this.automated_tasks_arr.id = this.sData["unsold"].us_id;
          }
          //console.log(JSON.parse(this.sData["sold"].us_value_in_arr));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAutomatedTasks() {
      axios
        .get("get_tasksautomated", {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.success) {
            console.log(res.data.success);
            if (res.data.success.leadwithnoappointment) {
              var leadwithnoappointmentrow1 = JSON.parse(
                res.data.success.leadwithnoappointment.row1
              );
              var leadwithnoappointmentrow2 = JSON.parse(
                res.data.success.leadwithnoappointment.row2
              );

              var leadwithnoappointmentrow3 = JSON.parse(
                res.data.success.leadwithnoappointment.row3
              );

              var leadwithnoappointmentrow4 = JSON.parse(
                res.data.success.leadwithnoappointment.row4
              );

              var leadwithnoappointmentrow5 = JSON.parse(
                res.data.success.leadwithnoappointment.row5
              );

              this.leadHandelWithNoAppoint = {
                text: "If Call Lead Handled With No Appointment",
                value: "",
                unit: "",
                slug: "leadwithnoappointment",
                status: 1,
                text_type: res.data.success.leadwithnoappointment.text_type,
                email_type: res.data.success.leadwithnoappointment.email_type,
                call_type: res.data.success.leadwithnoappointment.call_type,
                sms_template:
                  res.data.success.leadwithnoappointment.sms_template,
                sms_automate:
                  res.data.success.leadwithnoappointment.sms_automate,
                email_template:
                  res.data.success.leadwithnoappointment.email_template,
                email_automate:
                  res.data.success.leadwithnoappointment.email_automate,
                manager_email:
                  res.data.success.leadwithnoappointment.manager_email,
                manager_template:
                  res.data.success.leadwithnoappointment.manager_template,
                manager_automate:
                  res.data.success.leadwithnoappointment.manager_automate,
                time: res.data.success.leadwithnoappointment.time,
                hour: res.data.success.leadwithnoappointment.hour,
                min: res.data.success.leadwithnoappointment.min,
                daytime: res.data.success.leadwithnoappointment.daytime,
                data: JSON.parse(res.data.success.leadwithnoappointment.data),
                row1: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: leadwithnoappointmentrow1.text_type,
                  email_type: leadwithnoappointmentrow1.email_type,
                  call_type: leadwithnoappointmentrow1.call_type,
                  sms_template: leadwithnoappointmentrow1.sms_template,
                  email_template: leadwithnoappointmentrow1.email_template,
                  sms_automate: leadwithnoappointmentrow1.sms_automate,
                  email_automate: leadwithnoappointmentrow1.email_automate,
                  manager_email: leadwithnoappointmentrow1.manager_email,
                  manager_template: leadwithnoappointmentrow1.manager_template,
                  manager_automate: leadwithnoappointmentrow1.manager_automate,
                  time: leadwithnoappointmentrow1.time,
                  hour: leadwithnoappointmentrow1.hour,
                  min: leadwithnoappointmentrow1.min,
                  daytime: leadwithnoappointmentrow1.daytime,
                },
                row2: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: leadwithnoappointmentrow2.text_type,
                  email_type: leadwithnoappointmentrow2.email_type,
                  call_type: leadwithnoappointmentrow2.call_type,
                  sms_template: leadwithnoappointmentrow2.sms_template,
                  email_template: leadwithnoappointmentrow2.email_template,
                  sms_automate: leadwithnoappointmentrow2.sms_automate,
                  email_automate: leadwithnoappointmentrow2.email_automate,
                  manager_email: leadwithnoappointmentrow2.manager_email,
                  manager_template: leadwithnoappointmentrow2.manager_template,
                  manager_automate: leadwithnoappointmentrow2.manager_automate,
                  time: leadwithnoappointmentrow2.time,
                  hour: leadwithnoappointmentrow2.hour,
                  min: leadwithnoappointmentrow2.min,
                  daytime: leadwithnoappointmentrow2.daytime,
                },
                row3: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: leadwithnoappointmentrow3.text_type,
                  email_type: leadwithnoappointmentrow3.email_type,
                  call_type: leadwithnoappointmentrow3.call_type,
                  sms_template: leadwithnoappointmentrow3.sms_template,
                  email_template: leadwithnoappointmentrow3.email_template,
                  sms_automate: leadwithnoappointmentrow3.sms_automate,
                  email_automate: leadwithnoappointmentrow3.email_automate,
                  manager_email: leadwithnoappointmentrow3.manager_email,
                  manager_template: leadwithnoappointmentrow3.manager_template,
                  manager_automate: leadwithnoappointmentrow3.manager_automate,
                  time: leadwithnoappointmentrow3.time,
                  hour: leadwithnoappointmentrow3.hour,
                  min: leadwithnoappointmentrow3.min,
                  daytime: leadwithnoappointmentrow3.daytime,
                },
                row4: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: leadwithnoappointmentrow4.text_type,
                  email_type: leadwithnoappointmentrow4.email_type,
                  call_type: leadwithnoappointmentrow4.call_type,
                  sms_template: leadwithnoappointmentrow4.sms_template,
                  email_template: leadwithnoappointmentrow4.email_template,
                  sms_automate: leadwithnoappointmentrow4.sms_automate,
                  email_automate: leadwithnoappointmentrow4.email_automate,
                  manager_email: leadwithnoappointmentrow4.manager_email,
                  manager_template: leadwithnoappointmentrow4.manager_template,
                  manager_automate: leadwithnoappointmentrow4.manager_automate,
                  time: leadwithnoappointmentrow4.time,
                  hour: leadwithnoappointmentrow4.hour,
                  min: leadwithnoappointmentrow4.min,
                  daytime: leadwithnoappointmentrow4.daytime,
                },
                row5: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: leadwithnoappointmentrow5.text_type,
                  email_type: leadwithnoappointmentrow5.email_type,
                  call_type: leadwithnoappointmentrow5.call_type,
                  sms_template: leadwithnoappointmentrow5.sms_template,
                  email_template: leadwithnoappointmentrow5.email_template,
                  sms_automate: leadwithnoappointmentrow5.sms_automate,
                  email_automate: leadwithnoappointmentrow5.email_automate,
                  manager_email: leadwithnoappointmentrow5.manager_email,
                  manager_template: leadwithnoappointmentrow5.manager_template,
                  manager_automate: leadwithnoappointmentrow5.manager_automate,
                  time: leadwithnoappointmentrow5.time,
                  hour: leadwithnoappointmentrow5.hour,
                  min: leadwithnoappointmentrow5.min,
                  daytime: leadwithnoappointmentrow5.daytime,
                },
              };
            }

            if (res.data.success.leadmarksold) {
              var leadmarksoldrow1 = JSON.parse(
                res.data.success.leadmarksold.row1
              );

              var leadmarksoldrow2 = JSON.parse(
                res.data.success.leadmarksold.row2
              );

              var leadmarksoldrow3 = JSON.parse(
                res.data.success.leadmarksold.row3
              );

              var leadmarksoldrow4 = JSON.parse(
                res.data.success.leadmarksold.row4
              );

              var leadmarksoldrow5 = JSON.parse(
                res.data.success.leadmarksold.row5
              );
              this.leadmarksold = {
                text: "If Leadsheet Is Marked Sold",
                value: "",
                unit: "",
                slug: "leadmarksold",
                status: 1,
                text_type: res.data.success.leadmarksold.text_type,
                email_type: res.data.success.leadmarksold.email_type,
                call_type: res.data.success.leadmarksold.call_type,
                sms_template: res.data.success.leadmarksold.sms_template,
                email_template: res.data.success.leadmarksold.email_template,
                sms_automate: res.data.success.leadmarksold.sms_automate,
                email_automate: res.data.success.leadmarksold.email_automate,
                manager_email: res.data.success.leadmarksold.manager_email,
                manager_template:
                  res.data.success.leadmarksold.manager_template,
                manager_automate:
                  res.data.success.leadmarksold.manager_automate,
                time: res.data.success.leadmarksold.time,
                hour: res.data.success.leadmarksold.hour,
                min: res.data.success.leadmarksold.min,
                daytime: res.data.success.leadmarksold.daytime,
                data: JSON.parse(res.data.success.leadmarksold.data),
                row1: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: leadmarksoldrow1.text_type,
                  email_type: leadmarksoldrow1.email_type,
                  call_type: leadmarksoldrow1.call_type,
                  sms_template: leadmarksoldrow1.sms_template,
                  email_template: leadmarksoldrow1.email_template,
                  sms_automate: leadmarksoldrow1.sms_automate,
                  email_automate: leadmarksoldrow1.email_automate,
                  manager_email: leadmarksoldrow1.manager_email,
                  manager_template: leadmarksoldrow1.manager_template,
                  manager_automate: leadmarksoldrow1.manager_automate,
                  time: leadmarksoldrow1.time,
                  hour: leadmarksoldrow1.hour,
                  min: leadmarksoldrow1.min,
                  daytime: leadmarksoldrow1.daytime,
                  data: leadmarksoldrow1.data,
                },
                row2: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: leadmarksoldrow2.text_type,
                  email_type: leadmarksoldrow2.email_type,
                  call_type: leadmarksoldrow2.call_type,
                  sms_template: leadmarksoldrow2.sms_template,
                  email_template: leadmarksoldrow2.email_template,
                  sms_automate: leadmarksoldrow2.sms_automate,
                  email_automate: leadmarksoldrow2.email_automate,
                  manager_email: leadmarksoldrow2.manager_email,
                  manager_template: leadmarksoldrow2.manager_template,
                  manager_automate: leadmarksoldrow2.manager_automate,
                  time: leadmarksoldrow2.time,
                  hour: leadmarksoldrow2.hour,
                  min: leadmarksoldrow2.min,
                  daytime: leadmarksoldrow2.daytime,
                  data: leadmarksoldrow2.data,
                },
                row3: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: leadmarksoldrow3.text_type,
                  email_type: leadmarksoldrow3.email_type,
                  call_type: leadmarksoldrow3.call_type,
                  sms_template: leadmarksoldrow3.sms_template,
                  email_template: leadmarksoldrow3.email_template,
                  sms_automate: leadmarksoldrow3.sms_automate,
                  email_automate: leadmarksoldrow3.email_automate,
                  manager_email: leadmarksoldrow3.manager_email,
                  manager_template: leadmarksoldrow3.manager_template,
                  manager_automate: leadmarksoldrow3.manager_automate,
                  time: leadmarksoldrow3.time,
                  hour: leadmarksoldrow3.hour,
                  min: leadmarksoldrow3.min,
                  daytime: leadmarksoldrow3.daytime,
                  data: leadmarksoldrow3.data,
                },
                row4: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: leadmarksoldrow4.text_type,
                  email_type: leadmarksoldrow4.email_type,
                  call_type: leadmarksoldrow4.call_type,
                  sms_template: leadmarksoldrow4.sms_template,
                  email_template: leadmarksoldrow4.email_template,
                  sms_automate: leadmarksoldrow4.sms_automate,
                  email_automate: leadmarksoldrow4.email_automate,
                  manager_email: leadmarksoldrow4.manager_email,
                  manager_template: leadmarksoldrow4.manager_template,
                  manager_automate: leadmarksoldrow4.manager_automate,
                  time: leadmarksoldrow4.time,
                  hour: leadmarksoldrow4.hour,
                  min: leadmarksoldrow4.min,
                  daytime: leadmarksoldrow4.daytime,
                  data: leadmarksoldrow4.data,
                },
                row5: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: leadmarksoldrow5.text_type,
                  email_type: leadmarksoldrow5.email_type,
                  call_type: leadmarksoldrow5.call_type,
                  sms_template: leadmarksoldrow5.sms_template,
                  email_template: leadmarksoldrow5.email_template,
                  sms_automate: leadmarksoldrow5.sms_automate,
                  email_automate: leadmarksoldrow5.email_automate,
                  manager_email: leadmarksoldrow5.manager_email,
                  manager_template: leadmarksoldrow5.manager_template,
                  manager_automate: leadmarksoldrow5.manager_automate,
                  time: leadmarksoldrow5.time,
                  hour: leadmarksoldrow5.hour,
                  min: leadmarksoldrow5.min,
                  daytime: leadmarksoldrow5.daytime,
                  data: leadmarksoldrow5.data,
                },
              };
            }
            if (res.data.success.leadmarklost) {
              var leadmarklostrow1 = JSON.parse(
                res.data.success.leadmarklost.row1
              );

              var leadmarklostrow2 = JSON.parse(
                res.data.success.leadmarklost.row2
              );
              var leadmarklostrow3 = JSON.parse(
                res.data.success.leadmarklost.row3
              );

              var leadmarklostrow4 = JSON.parse(
                res.data.success.leadmarklost.row4
              );

              var leadmarklostrow5 = JSON.parse(
                res.data.success.leadmarklost.row5
              );
              this.leadmarklost = {
                text: "If Leadsheet Is Marked Lost",
                value: "",
                unit: "",
                slug: "leadmarklost",
                status: 1,
                text_type: res.data.success.leadmarklost.text_type,
                email_type: res.data.success.leadmarklost.email_type,
                call_type: res.data.success.leadmarklost.call_type,
                sms_template: res.data.success.leadmarklost.sms_template,
                email_template: res.data.success.leadmarklost.email_template,
                sms_automate: res.data.success.leadmarklost.sms_automate,
                email_automate: res.data.success.leadmarklost.email_automate,
                manager_email: res.data.success.leadmarklost.manager_email,
                manager_template:
                  res.data.success.leadmarklost.manager_template,
                manager_automate:
                  res.data.success.leadmarklost.manager_automate,
                time: res.data.success.leadmarklost.time,
                hour: res.data.success.leadmarklost.hour,
                min: res.data.success.leadmarklost.min,
                daytime: res.data.success.leadmarklost.daytime,
                data: JSON.parse(res.data.success.leadmarklost.data),
                row1: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: leadmarklostrow1.text_type,
                  email_type: leadmarklostrow1.email_type,
                  call_type: leadmarklostrow1.call_type,
                  sms_template: leadmarklostrow1.sms_template,
                  email_template: leadmarklostrow1.email_template,
                  sms_automate: leadmarklostrow1.sms_automate,
                  email_automate: leadmarklostrow1.email_automate,
                  manager_email: leadmarklostrow1.manager_email,
                  manager_template: leadmarklostrow1.manager_template,
                  manager_automate: leadmarklostrow1.manager_automate,
                  time: leadmarklostrow1.time,
                  hour: leadmarklostrow1.hour,
                  min: leadmarklostrow1.min,
                  daytime: leadmarklostrow1.daytime,
                  data: leadmarklostrow1.data,
                },
                row2: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: leadmarklostrow2.text_type,
                  email_type: leadmarklostrow2.email_type,
                  call_type: leadmarklostrow2.call_type,
                  sms_template: leadmarklostrow2.sms_template,
                  email_template: leadmarklostrow2.email_template,
                  sms_automate: leadmarklostrow2.sms_automate,
                  email_automate: leadmarklostrow2.email_automate,
                  manager_email: leadmarklostrow2.manager_email,
                  manager_template: leadmarklostrow2.manager_template,
                  manager_automate: leadmarklostrow2.manager_automate,
                  time: leadmarklostrow2.time,
                  hour: leadmarklostrow2.hour,
                  min: leadmarklostrow2.min,
                  daytime: leadmarklostrow2.daytime,
                  data: leadmarklostrow2.data,
                },
                row3: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: leadmarklostrow3.text_type,
                  email_type: leadmarklostrow3.email_type,
                  call_type: leadmarklostrow3.call_type,
                  sms_template: leadmarklostrow3.sms_template,
                  email_template: leadmarklostrow3.email_template,
                  sms_automate: leadmarklostrow3.sms_automate,
                  email_automate: leadmarklostrow3.email_automate,
                  manager_email: leadmarklostrow3.manager_email,
                  manager_template: leadmarklostrow3.manager_template,
                  manager_automate: leadmarklostrow3.manager_automate,
                  time: leadmarklostrow3.time,
                  hour: leadmarklostrow3.hour,
                  min: leadmarklostrow3.min,
                  daytime: leadmarklostrow3.daytime,
                  data: leadmarklostrow3.data,
                },
                row4: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: leadmarklostrow4.text_type,
                  email_type: leadmarklostrow4.email_type,
                  call_type: leadmarklostrow4.call_type,
                  sms_template: leadmarklostrow4.sms_template,
                  email_template: leadmarklostrow4.email_template,
                  sms_automate: leadmarklostrow4.sms_automate,
                  email_automate: leadmarklostrow4.email_automate,
                  manager_email: leadmarklostrow4.manager_email,
                  manager_template: leadmarklostrow4.manager_template,
                  manager_automate: leadmarklostrow4.manager_automate,
                  time: leadmarklostrow4.time,
                  hour: leadmarklostrow4.hour,
                  min: leadmarklostrow4.min,
                  daytime: leadmarklostrow4.daytime,
                  data: leadmarklostrow4.data,
                },
                row5: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: leadmarklostrow5.text_type,
                  email_type: leadmarklostrow5.email_type,
                  call_type: leadmarklostrow5.call_type,
                  sms_template: leadmarklostrow5.sms_template,
                  email_template: leadmarklostrow5.email_template,
                  sms_automate: leadmarklostrow5.sms_automate,
                  email_automate: leadmarklostrow5.email_automate,
                  manager_email: leadmarklostrow5.manager_email,
                  manager_template: leadmarklostrow5.manager_template,
                  manager_automate: leadmarklostrow5.manager_automate,
                  time: leadmarklostrow5.time,
                  hour: leadmarklostrow5.hour,
                  min: leadmarklostrow5.min,
                  daytime: leadmarklostrow5.daytime,
                  data: leadmarklostrow5.data,
                },
              };
            }
            if (res.data.success.soldcustommerbirthday) {
              var soldcustommerbirthdayrow1 = JSON.parse(
                res.data.success.soldcustommerbirthday.row1
              );

              var soldcustommerbirthdayrow2 = JSON.parse(
                res.data.success.soldcustommerbirthday.row2
              );

              var soldcustommerbirthdayrow3 = JSON.parse(
                res.data.success.soldcustommerbirthday.row3
              );

              var soldcustommerbirthdayrow4 = JSON.parse(
                res.data.success.soldcustommerbirthday.row4
              );

              var soldcustommerbirthdayrow5 = JSON.parse(
                res.data.success.soldcustommerbirthday.row5
              );
              this.soldcustommerbirthday = {
                text: "If It’s Sold Customer’s Birthday",
                value: "",
                unit: "",
                slug: "soldcustommerbirthday",
                status: 1,
                text_type: res.data.success.soldcustommerbirthday.text_type,
                email_type: res.data.success.soldcustommerbirthday.email_type,
                call_type: res.data.success.soldcustommerbirthday.call_type,
                sms_template:
                  res.data.success.soldcustommerbirthday.sms_template,
                email_template:
                  res.data.success.soldcustommerbirthday.email_template,
                sms_automate:
                  res.data.success.soldcustommerbirthday.sms_automate,
                email_automate:
                  res.data.success.soldcustommerbirthday.email_automate,
                manager_template:
                  res.data.success.soldcustommerbirthday.manager_template,
                manager_email:
                  res.data.success.soldcustommerbirthday.manager_email,
                manager_automate:
                  res.data.success.soldcustommerbirthday.manager_automate,
                time: res.data.success.soldcustommerbirthday.time,
                hour: res.data.success.soldcustommerbirthday.hour,
                min: res.data.success.soldcustommerbirthday.min,
                daytime: res.data.success.soldcustommerbirthday.daytime,
                data: JSON.parse(res.data.success.soldcustommerbirthday.data),
                row1: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: soldcustommerbirthdayrow1.text_type,
                  email_type: soldcustommerbirthdayrow1.email_type,
                  call_type: soldcustommerbirthdayrow1.call_type,
                  sms_template: soldcustommerbirthdayrow1.sms_template,
                  email_template: soldcustommerbirthdayrow1.email_template,
                  sms_automate: soldcustommerbirthdayrow1.sms_automate,
                  email_automate: soldcustommerbirthdayrow1.email_automate,
                  manager_email: soldcustommerbirthdayrow1.manager_email,
                  manager_template: soldcustommerbirthdayrow1.manager_template,
                  manager_automate: soldcustommerbirthdayrow1.manager_automate,
                  time: soldcustommerbirthdayrow1.time,
                  hour: soldcustommerbirthdayrow1.hour,
                  min: soldcustommerbirthdayrow1.min,
                  daytime: soldcustommerbirthdayrow1.daytime,
                  data: soldcustommerbirthdayrow1.data,
                },
                row2: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: soldcustommerbirthdayrow2.text_type,
                  email_type: soldcustommerbirthdayrow2.email_type,
                  call_type: soldcustommerbirthdayrow2.call_type,
                  sms_template: soldcustommerbirthdayrow2.sms_template,
                  email_template: soldcustommerbirthdayrow2.email_template,
                  sms_automate: soldcustommerbirthdayrow2.sms_automate,
                  email_automate: soldcustommerbirthdayrow2.email_automate,
                  manager_email: soldcustommerbirthdayrow2.manager_email,
                  manager_template: soldcustommerbirthdayrow2.manager_template,
                  manager_automate: soldcustommerbirthdayrow2.manager_automate,
                  time: soldcustommerbirthdayrow2.time,
                  hour: soldcustommerbirthdayrow2.hour,
                  min: soldcustommerbirthdayrow2.min,
                  daytime: soldcustommerbirthdayrow2.daytime,
                  data: soldcustommerbirthdayrow2.data,
                },
                row3: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: soldcustommerbirthdayrow3.text_type,
                  email_type: soldcustommerbirthdayrow3.email_type,
                  call_type: soldcustommerbirthdayrow3.call_type,
                  sms_template: soldcustommerbirthdayrow3.sms_template,
                  email_template: soldcustommerbirthdayrow3.email_template,
                  sms_automate: soldcustommerbirthdayrow3.sms_automate,
                  email_automate: soldcustommerbirthdayrow3.email_automate,
                  manager_email: soldcustommerbirthdayrow3.manager_email,
                  manager_template: soldcustommerbirthdayrow3.manager_template,
                  manager_automate: soldcustommerbirthdayrow3.manager_automate,
                  time: soldcustommerbirthdayrow3.time,
                  hour: soldcustommerbirthdayrow3.hour,
                  min: soldcustommerbirthdayrow3.min,
                  daytime: soldcustommerbirthdayrow3.daytime,
                  data: soldcustommerbirthdayrow3.data,
                },
                row4: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: soldcustommerbirthdayrow4.text_type,
                  email_type: soldcustommerbirthdayrow4.email_type,
                  call_type: soldcustommerbirthdayrow4.call_type,
                  sms_template: soldcustommerbirthdayrow4.sms_template,
                  email_template: soldcustommerbirthdayrow4.email_template,
                  sms_automate: soldcustommerbirthdayrow4.sms_automate,
                  email_automate: soldcustommerbirthdayrow4.email_automate,
                  manager_email: soldcustommerbirthdayrow4.manager_email,
                  manager_template: soldcustommerbirthdayrow4.manager_template,
                  manager_automate: soldcustommerbirthdayrow4.manager_automate,
                  time: soldcustommerbirthdayrow4.time,
                  hour: soldcustommerbirthdayrow4.hour,
                  min: soldcustommerbirthdayrow4.min,
                  daytime: soldcustommerbirthdayrow4.daytime,
                  data: soldcustommerbirthdayrow4.data,
                },
                row5: {
                  value: "",
                  unit: "",
                  status: 1,
                  text_type: soldcustommerbirthdayrow5.text_type,
                  email_type: soldcustommerbirthdayrow5.email_type,
                  call_type: soldcustommerbirthdayrow5.call_type,
                  sms_template: soldcustommerbirthdayrow5.sms_template,
                  email_template: soldcustommerbirthdayrow5.email_template,
                  sms_automate: soldcustommerbirthdayrow5.sms_automate,
                  email_automate: soldcustommerbirthdayrow5.email_automate,
                  manager_email: soldcustommerbirthdayrow5.manager_email,
                  manager_template: soldcustommerbirthdayrow5.manager_template,
                  manager_automate: soldcustommerbirthdayrow5.manager_automate,
                  time: soldcustommerbirthdayrow5.time,
                  hour: soldcustommerbirthdayrow5.hour,
                  min: soldcustommerbirthdayrow5.min,
                  daytime: soldcustommerbirthdayrow5.daytime,
                  data: soldcustommerbirthdayrow5.data,
                },
              };
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDealerDetail() {
      axios
        .get("get_dealer_detail", {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.dealer_detail = res.data.success;

            this.round_robin = this.dealer_detail.round_robin_on_users;
            this.agent = this.dealer_detail.round_robin_off_users;
            this.defaultsource = this.dealer_detail.default_lead_source;
            this.getDefaultLeadSource(this.dealer_detail.default_lead_source);
            this.xml_email_forwarding_address =
              this.dealer_detail.forwarding_email;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSchedule() {
      axios
        .get("storeschedule", {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          if (res.data.success) {
            //console.log(res.data)
            this.userSchedule = res.data.success;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateSchedule() {
      //console.log(this.userSchedule)
      this.userSchedule.forEach((value) => {
        if (value.status == true) {
          var open = value.start_time;
          var close = value.end_time;

          if (
            open != "" &&
            open != null &&
            open != undefined &&
            open != "undefined" &&
            close != "" &&
            close != null &&
            close != undefined &&
            close != "undefined"
          ) {
            //convert both time into timestamp
            var stt = new Date("November 13, 2019 " + open);
            stt = stt.getTime();

            var endt = new Date("November 13, 2019 " + close);
            if (stt > endt) {
              $("#errorMessage" + value.id).html(
                "Close time must be greater then start time."
              );
              $("#errorMessage" + value.id).show();
              this.errorMsg = true;
            }
          } else {
            $("#errorMessage" + value.id).html("Enter Open & Close Time");
            $("#errorMessage" + value.id).show();
            this.errorMsg = true;
          }
        }
      });
      if (!this.errorMsg) {
        axios
          .post("update_storeschedule", this.userSchedule, {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          })
          .then((res) => {
            if (res.data.success) {
              alert(res.data.success);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    updateSmtpDetails() {
      this.btnLoader = true;
      axios
        .post("admin/update_dealer_smtp", this.dealer_detail, {
          headers: {
            Authorization: "Bearer " + this.$storage.get("auth").token,
          },
        })
        .then((res) => {
          //console.log(res);
          if (res.data.success) {
            this.btnLoader = false;
            console.log("dealer smtp details updated");
            this.$nextTick(() => {
              this.getDealerDetail();
            });
          }
        })
        .catch((err) => {
          this.btnLoader = false;
          console.log(err);
        });
    },
    updateXmlEmailForwardingAddress() {
      axios
        .post(
          "admin/update_forwarding_email_address",
          {
            email: this.xml_email_forwarding_address,
            dealer_id: this.dealer_detail.dl_id,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$storage.get("auth").token,
            },
          }
        )
        .then((res) => {
          //console.log(res);
          if (res.data.success) {
            console.log("dealer smtp details updated");
            this.$nextTick(() => {
              this.getDealerDetail();
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    $('.switch input[type="checkbox"]').click(function () {
      if ($(this).is(":checked")) {
        $(this).parent().parent().addClass("checka");
      } else if ($(this).is(":not(:checked)")) {
        $(this).parent().parent().removeClass("checka");
      }
    });
    if (this.$route.query.fbToken) {
      this.getPages();
    }
    let v = this;
    this.$root.$on("all", function () {
      v.all = true;
      v.getAllEmployees();
    });
    this.$root.$on("removeall", function () {
      v.selected_users = [];
      v.users = [];
    });

    this.$root.$on("edit_checkallusers", function () {
      v.responsetime = v.manageragent;
    });

    this.$root.$on("edit_unselectallusers", function () {
      v.responsetime = [];
    });

    // this.$root.$on("edit_unselectallsources", function () {
    //   v.responsetime = [];
    // });
    // this.$root.$on("edit_checkallsources", function () {
    //   v.responsetime = v.manageragent;
    // });
  },
};
</script>
<style >
.working-hours {
  background: #ffffff;
  box-shadow: 0px 4px 8px rgba(49, 81, 161, 0.08);
  border-radius: 10px;
  margin-bottom: 15px;
  padding: 1.25rem;
}
.time-picker-overlay {
  outline: none;
}

.day-stripe {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding-right: 15px;
  padding-left: 15px;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.day-hours-div,
.day-hours-heading {
  width: 20%;
  padding-top: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-flex: 0;
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 16px;
}
.day-hours-div {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.day-hours-heading,
.day-hour-time-heading {
  font-weight: 800;
}
.day-hour-time-heading {
  padding: 10px 18px !important;
}
.day-hours-div label.vue-js-switch {
  margin-right: 15px;
}
.day-hours-div .v-switch-label {
  text-transform: uppercase;
}
.hours-open-div {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 30%;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}

.hours-open-div.close-hr {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: block;
  border-right-style: none;
}
.hours-open-div-wrapper {
  padding: 10px 12px;
  position: relative;
  display: block;
  width: 125px;
  margin-bottom: 0;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.time-error {
  color: #eb6663;
  padding: 12px;
}

/* .hours-open-div-wrapper img{
    margin-top: 3px;
    width: 14px;
    position: absolute;
    right: 13px;
    top: 18px;
    opacity: 0.6;
    z-index: 1;
}
.working-hours{
    margin-top: 25px;
    border: 1px solid #0000001a;
    border-radius: 5px;
    box-shadow: 1px 1px 3px 0 rgba(0,0,0,.2);
}
.switch-checkbox{
    margin-right: 15px;
    margin-bottom: 0;
} */
.vue__time-picker input.display-time {
  margin: 0;
  font-size: 18px;
  width: 100%;
  color: #353535;
  border: none;
  font-weight: 400;
  cursor: pointer;
  z-index: 2;
  background: #0000;
  cursor: pointer;
}
.vue__time-picker input.display-time:focus {
  border: none;
  outline: none;
  cursor: pointer;
}
.vue__time-picker input.display-time::-webkit-input-placeholder,
.vue__time-picker input.display-time::-ms-input-placeholder,
.vue__time-picker input.display-time::placeholder,
.vue__time-picker input.display-time:-ms-input-placeholder {
  color: #bbb;
}
div.error-message-form,
div.plan-msg {
  position: absolute;
  background: #de2f2f;
  padding: 4px 8px;
  min-width: 160px;
  font-size: 14px;
  font-weight: 300;
  border-radius: 0;
  color: #fff;
  left: 0px;
  z-index: 10;
  top: 65px;
  box-shadow: 0px 2px 3px -1px #000;
}
.input-group div.error-message-form {
  top: 33px;
  left: 30px;
}
div.error-message-form:before,
div.plan-msg:before {
  bottom: 100%;
  left: 30px;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(232, 232, 232, 0);
  border-bottom-color: #de2f2f;
  border-width: 7px;
  margin-left: -7px;
}
.error-message-form .fa-sort-asc {
  top: -9px !important;
  font-size: 27px !important;
  color: #e8e8e8 !important;
  left: 10px !important;
}

a.fb {
  font-family: Lucida Grande, Helvetica Neue, Helvetica, Arial, sans-serif;
  display: inline-block;
  font-size: 14px;
  padding: 13px 30px 15px 44px;
  background: #3a5a97;
  color: #fff;
  text-shadow: 0 -1px 0 rgba(0, 0, 20, 0.4);
  text-decoration: none;
  line-height: 1;
  position: relative;
  border-radius: 5px;
  cursor: pointer;
}

.connect:before {
  display: inline-block;
  position: relative;
  background-image: url(data:image/png;base64,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);
  height: 23px;
  background-repeat: no-repeat;
  background-position: 0px 3px;
  text-indent: -9999px;
  text-align: center;
  width: 29px;
  line-height: 23px;
  margin: -8px 7px -7px -30px;
  padding: 2 25px 0 0;
  content: "f";
}
.setting-tables .table .customWidth {
  width: 500px;
}
.setting-tables .table .customWidth input {
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.fbpage {
  margin-top: 34px;
}
.rawleads {
  text-decoration: none;
  display: -ms-flexbox;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  /* display: flex; */
  border: 1px solid #19cd9d;
  background: #19cd9d;
  padding: 6px 14px;
  border-radius: 30px;
  text-transform: capitalize;
  /* line-height: 1; */
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  align-items: center;
  display: inline-block;
}
.rawleads:hover {
  color: white;
}

.number {
  font-size: 25px;
}
.working > .card {
  overflow: unset !important;
}
.show-options {
  top: 34px !important;
}
</style>
<style scoped>
.mint-box {
  margin-bottom: 79px;
}
</style>